import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import CachedIcon from "@mui/icons-material/Cached";
import PacientesService from "../services/PacientesService";
import PreciosSucursalService from "../services/PreciosSucursalService";
import DoctoresService from "../services/DoctoresService";
import ConveniosService from "../services/ConveniosService";
import SolicitudesService from "../services/SolicitudesService"
import SucursalesService from "../services/SucursalesService"
import SolicitudesEstudiosService from "../services/SolicitudesEstudiosService"
import PreciosEstudioService from "../services/PreciosEstudioService";
import EstudiosService from "../services/EstudiosService"
import HistorialEstudiosService from "../services/HistorialEstudiosService";

import CotizacionesService from "../services/CotizacionesService";
import CotizacionesEstudiosService from "../services/CotizacionesEstudiosService";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditSquare";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MuestrasService from "../services/MuestrasService";
import CajaService from "../services/CajaService";
import EstudiosIntService from "../services/EstudiosIntService";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import Chip from '@mui/material/Chip';
import templateFile from "../templates/archivoPacientes.xlsx";
import { filterAndRankEstudios } from "../utils/estudioFilterUtils";
import {
    CircularProgress,
    Autocomplete,
    Grid,
    TextField,
    FormControl,
    Snackbar,
    Alert,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    InputLabel,
    Paper,
    Typography,
    OutlinedInput,
    Stack,
    Box,
    IconButton,
    Button,
    Tooltip,
    tooltipClasses,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Checkbox,
    InputAdornment,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as XLSX from "xlsx";

const normalizarEdad = (val) => {
    if (!val) return "";
    const str = String(val).trim();
    if (str === "") return "";
    if (/^\d+$/.test(str)) {
        return `${str} AÑOS`;
    }
    return str.toUpperCase().replace(/DÍAS/g, "DIAS");
};

const normalizarFechaNacimiento = (val) => {
    if (!val) return "";
    let str = String(val).trim();
    if (str === "") return "";

    // Si ya tiene formato YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        return str;
    }

    // Intentar analizar DD/MM/YYYY o DD-MM-YYYY
    const match = str.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (match) {
        const dia = match[1].padStart(2, "0");
        const mes = match[2].padStart(2, "0");
        const anio = match[3];
        return `${anio}-${mes}-${dia}`;
    }

    // Intentar análisis general de fechas
    const dateObj = new Date(val);
    if (!isNaN(dateObj.getTime())) {
        const yyyy = dateObj.getFullYear();
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
        const dd = String(dateObj.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    }

    return "";
};

const calcularEdadDesdeFecha = (fechaNacStr) => {
    if (!fechaNacStr) return "";
    const birthDate = new Date(fechaNacStr + "T00:00:00");
    if (isNaN(birthDate.getTime())) return "";

    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
        months--;
        const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        days += prevMonth.getDate();
    }
    if (months < 0) {
        years--;
        months += 12;
    }

    if (years >= 1) {
        return `${years} AÑOS`;
    } else if (months >= 1) {
        return `${months} MESES`;
    } else if (days >= 0) {
        return `${days} DIAS`;
    }
    return "";
};

const normalizarSexo = (val) => {
    if (!val) return "";
    const str = String(val).trim().toUpperCase();
    if (str.startsWith("M")) return "M";
    if (str.startsWith("F")) return "F";
    if (str.startsWith("H")) return "M"; // Hombre
    if (str.startsWith("MASCULINO")) return "M";
    if (str.startsWith("FEMENINO")) return "F";
    return "";
};

const CargaMasiva = () => {

    useEffect(() => {
        document.title = "Carga masiva de solicitudes";
        getPacientes();
        getDoctores();
        getConvenios();
        getSucursales();
    }, []);


    useEffect(() => {
        fetchEstudiosOptions();
        fetchPrecios();
    }, []);

    const parseHora = (value) => {
        if (value === null || value === undefined || value === "" || value === "seleccione") {
            return null;
        }

        const texto = `${value}`.trim();
        if (!texto.includes(":")) return null;

        const [hora, minuto] = texto.split(":");
        const horas = Number(hora);
        const minutos = Number(minuto || 0);

        if (Number.isNaN(horas) || Number.isNaN(minutos)) return null;
        return horas * 60 + minutos;
    };

    const calcularFechaEntrega = (dias) => {
        if (dias === null || dias === undefined || dias === "") return "";

        const texto = `${dias}`.trim();
        const match = texto.match(/-?\d+(?:\.\d+)?/);
        const num = match ? Number(match[0]) : Number(texto);

        if (Number.isNaN(num) || num < 0) return "";

        const fecha = new Date();
        fecha.setDate(fecha.getDate() + num);
        const yyyy = fecha.getFullYear();
        const mm = String(fecha.getMonth() + 1).padStart(2, "0");
        const dd = String(fecha.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    const normalizarBooleano = (value) => {
        if (value === true || value === 1 || value === "true" || value === "1" || value === "si" || value === "SI") {
            return true;
        }
        return false;
    };

    const getDiaActual = () => {
        const dia = new Date().getDay();
        const dias = {
            0: "Domingo",
            1: "Lunes",
            2: "Martes",
            3: "Miercoles",
            4: "Jueves",
            5: "Viernes",
            6: "Sabados",
        };
        return dias[dia] || "";
    };

    const normalizarTexto = (value) => {
        if (value === null || value === undefined) return "";
        return `${value}`.trim().toLowerCase();
    };

    const normalizarDia = (value) => {
        const texto = normalizarTexto(value)
            .replace(/\s+/g, "")
            .replace(/[áàäâ]/g, "a")
            .replace(/[éèëê]/g, "e")
            .replace(/[íìïî]/g, "i")
            .replace(/[óòöô]/g, "o")
            .replace(/[úùüû]/g, "u");

        if (["lunesaviernes", "lunesaviernes"].includes(texto)) {
            return "LunesAviernes";
        }

        if (["sabadodomingo", "sabadoydomingo", "sabadosydomingo"].includes(texto)) {
            return "SabadoDomingo";
        }

        const diasMap = {
            lunes: "Lunes",
            martes: "Martes",
            miercoles: "Miercoles",
            jueves: "Jueves",
            viernes: "Viernes",
            sabados: "Sabados",
            domingo: "Domingo",
        };

        return diasMap[texto] || `${value}`.trim();
    };

    const cumpleDia = (diasConfig, diaActual) => {
        if (!diasConfig || diasConfig === "seleccione") return false;

        const valor = normalizarDia(diasConfig);
        const dia = normalizarDia(diaActual);

        if (valor === "LunesAviernes") {
            return ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes"].includes(dia);
        }

        if (valor === "SabadoDomingo") {
            return ["Sabados", "Domingo"].includes(dia);
        }

        return valor === dia;
    };

    async function getPacientes() {
        const resultado = await PacientesService.getPacientes();
        setPacientes(resultado.data.pacientes);
    }
    async function getDoctores() {
        const resultado = await DoctoresService.getDoctores();
        setDoctores(resultado.data.doctores);
    }
    async function getConvenios() {
        const resultado = await ConveniosService.getConvenios();
        setEmpresas(resultado.data.convenios);
    }

    async function getSucursales() {
        const resultado = await SucursalesService.getSucursales();
        setSucursales(resultado.data.sucursales);
    }
    async function fetchEstudiosOptions() {
        try {
            const res = await EstudiosService.getEstudios();
            const data = res.data.estudios || [];
            setEstudiosOptions(data);
        } catch (err) {
            console.error(err);
        }
    }

    async function fetchPrecios() {
        try {
            const resultado = await PreciosEstudioService.getPrecios();
            const data = resultado.data.precios;
            const map = {};
            (data || []).forEach((p) => {
                if (!map[p.idListaPrecio]) {
                    map[p.idListaPrecio] = {
                        nombre: p.nombreLista, // suponiendo que venga en el resultado
                        precios: {}
                    };
                }
                map[p.idListaPrecio].precios[p.idEstudio] = p.precio;
            });
            setPreciosByLista(map);
        } catch (err) {
            console.error(err);
        }
    }

    function mostrarMensaje(mensaje) {
        Swal.fire({
            title: "",
            text: mensaje,
            icon: "success",
            confirmButtonText: "Aceptar",
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            }
        });
    }
    function mostrarMensajeSolicitud(mensaje) {
        Swal.fire({
            title: "",
            text: mensaje,
            icon: "success",
            confirmButtonText: "Aceptar",
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.close();
            }
        });
    }
    function mostrarError(mensaje) {
        Swal.fire({
            title: "¡Error!",
            text: mensaje,
            icon: "error",
            confirmButtonText: "Aceptar",
        });
    }

    function reloadPage() {
        window.location.reload();
    }

    const [selectedPaciente, setSelectedPaciente] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [nombreDoctor, setNombreDoctor] = useState("");
    const [apPaternoDoctor, setApPaternoDoctor] = useState("");
    const [apMaternoDoctor, setApMaternoDoctor] = useState("");
    const [emailDoctor, setEmailDoctor] = useState("");
    const [telefonoDoctor, setTelefonoDoctor] = useState("");

    const [cantidadDoctores, setCantidadDoctores] = useState(1);

    // Doctor 2
    const [selectedDoctor2, setSelectedDoctor2] = useState(null);
    const [nombreDoctor2, setNombreDoctor2] = useState("");
    const [apPaternoDoctor2, setApPaternoDoctor2] = useState("");
    const [apMaternoDoctor2, setApMaternoDoctor2] = useState("");
    const [emailDoctor2, setEmailDoctor2] = useState("");
    const [telefonoDoctor2, setTelefonoDoctor2] = useState("");
    const [enviarEmailD2, setEnviarEmailD2] = useState("no");
    const [enviarWhatsappD2, setEnviarWhatsappD2] = useState("no");
    const [errorNombreDoctor2, setErrorNombreDoctor2] = useState(false);
    const [errorApPaternoDoctor2, setErrorApPaternoDoctor2] = useState(false);
    const [editModeM2, setEditModeM2] = useState(false);

    // Doctor 3
    const [selectedDoctor3, setSelectedDoctor3] = useState(null);
    const [nombreDoctor3, setNombreDoctor3] = useState("");
    const [apPaternoDoctor3, setApPaternoDoctor3] = useState("");
    const [apMaternoDoctor3, setApMaternoDoctor3] = useState("");
    const [emailDoctor3, setEmailDoctor3] = useState("");
    const [telefonoDoctor3, setTelefonoDoctor3] = useState("");
    const [enviarEmailD3, setEnviarEmailD3] = useState("no");
    const [enviarWhatsappD3, setEnviarWhatsappD3] = useState("no");
    const [errorNombreDoctor3, setErrorNombreDoctor3] = useState(false);
    const [errorApPaternoDoctor3, setErrorApPaternoDoctor3] = useState(false);
    const [editModeM3, setEditModeM3] = useState(false);
    const [esComisionD, setEsComisionD] = useState(false);
    const [esComisionD2, setEsComisionD2] = useState(false);
    const [esComisionD3, setEsComisionD3] = useState(false);
    const [requiereFactura, setRequiereFactura] = useState(false);
    const [errorDescuentoGeneral, setErrorDescuentoGeneral] = useState("");
    const [erroresDescuentoEstudios, setErroresDescuentoEstudios] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [nombre, setNombre] = useState("");
    const [apPaterno, setApPaterno] = useState("");
    const [apMaterno, setApMaterno] = useState("");
    const [fechaNac, setFechaNac] = useState("");
    const [edad, setEdad] = useState("");
    const [email, setEmail] = useState("");
    const [sexo, setSexo] = useState("");
    const [telefonoCelular, setTelefonoCelular] = useState("");
    const [numCuarto, setNumCuarto] = useState("");
    const [motivoDescuento, setMotivoDescuento] = useState("");
    const [errorNombre, setErrorNombre] = useState(false);
    const [errorApPaterno, setErrorApPaterno] = useState(false);
    const [errorNombreDoctor, setErrorNombreDoctor] = useState(false);
    const [errorApPaternoDoctor, setErrorApPaternoDoctor] = useState(false);
    const [errorEdad, setErrorEdad] = useState(false);
    const [errorSexo, setErrorSexo] = useState(false);
    const [direccion, setDireccion] = useState("");
    const [colonia, setColonia] = useState("");
    const [cPostal, setCPostal] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [estado, setEstado] = useState("seleccione");
    const [ine, setIne] = useState("");
    const [conversion, setConversion] = useState("");
    const [pacientesExcel, setPacientesExcel] = useState([]);
    const [nombreArchivo, setNombreArchivo] = useState("");
    const [cargandoExcel, setCargandoExcel] = useState(false);

    const encontrarPacienteExistente = (pExcel) => {
        const nom = String(pExcel.nombre || "").trim().toLowerCase();
        const pat = String(pExcel.apPaterno || "").trim().toLowerCase();
        const mat = String(pExcel.apMaterno || "").trim().toLowerCase();

        return pacientes.find((p) => {
            const pNom = String(p.nombre || "").trim().toLowerCase();
            const pPat = String(p.apPaterno || "").trim().toLowerCase();
            const pMat = String(p.apMaterno || "").trim().toLowerCase();
            return pNom === nom && pPat === pat && pMat === mat;
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setPacientesExcel([]);
            setNombreArchivo("");
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
            mostrarError("El archivo seleccionado no es compatible. Solo se permiten archivos Excel (.xlsx o .xls).");
            e.target.value = "";
            setPacientesExcel([]);
            setNombreArchivo("");
            return;
        }

        setNombreArchivo(file.name);
        setCargandoExcel(true);

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });

                if (jsonData.length < 2) {
                    mostrarError("El archivo de Excel no contiene suficientes datos (debe tener una fila de encabezados y al menos una fila de datos).");
                    e.target.value = "";
                    setPacientesExcel([]);
                    setNombreArchivo("");
                    setCargandoExcel(false);
                    return;
                }

                const headers = jsonData[0].map(h => String(h).trim().toUpperCase());

                const getIndex = (name) => headers.indexOf(name.toUpperCase());
                const idxNombre = getIndex("NOMBRE");
                const idxApPaterno = getIndex("APELLIDO_PATERNO");
                const idxApMaterno = getIndex("APELLIDO_MATERNO");
                const idxSexo = getIndex("SEXO");
                const idxFechaNac = getIndex("FECHA_NACO") === -1 ? getIndex("FECHA_NACIMIENTO") : getIndex("FECHA_NACO");
                const idxEdad = getIndex("EDAD");
                const idxEmail = getIndex("EMAIL");
                const idxTelefono = getIndex("TELEFONO");
                const idxDireccion = getIndex("DIRECCION");
                const idxColonia = getIndex("COLONIA");
                const idxCp = getIndex("CP");
                const idxIne = getIndex("INE_PASAPORTE");
                const idxNumCuarto = getIndex("NUM_CUARTO");

                if (idxNombre === -1 || idxApPaterno === -1) {
                    mostrarError("El archivo de Excel debe contener las columnas 'NOMBRE' y 'APELLIDO_PATERNO' obligatoriamente.");
                    e.target.value = "";
                    setPacientesExcel([]);
                    setNombreArchivo("");
                    setCargandoExcel(false);
                    return;
                }

                const rows = [];
                for (let i = 1; i < jsonData.length; i++) {
                    const rowData = jsonData[i];
                    if (!rowData || rowData.length === 0) continue;

                    const nameVal = rowData[idxNombre] ? String(rowData[idxNombre]).trim() : "";
                    if (!nameVal) continue;

                    const pFechaNac = idxFechaNac !== -1 && rowData[idxFechaNac] ? String(rowData[idxFechaNac]).trim() : "";
                    const fechaNacNorm = normalizarFechaNacimiento(pFechaNac);

                    const pEdad = idxEdad !== -1 && rowData[idxEdad] ? String(rowData[idxEdad]).trim() : "";
                    let edadFinal = "";
                    if (pEdad) {
                        edadFinal = normalizarEdad(pEdad);
                    } else if (fechaNacNorm) {
                        edadFinal = calcularEdadDesdeFecha(fechaNacNorm);
                    }

                    const item = {
                        nombre: nameVal,
                        apPaterno: rowData[idxApPaterno] ? String(rowData[idxApPaterno]).trim() : "",
                        apMaterno: idxApMaterno !== -1 && rowData[idxApMaterno] ? String(rowData[idxApMaterno]).trim() : "",
                        sexo: idxSexo !== -1 && rowData[idxSexo] ? normalizarSexo(rowData[idxSexo]) : "",
                        fechaNacimiento: fechaNacNorm,
                        edad: edadFinal,
                        email: idxEmail !== -1 && rowData[idxEmail] ? String(rowData[idxEmail]).trim() : "",
                        telefonoCelular: idxTelefono !== -1 && rowData[idxTelefono] ? String(rowData[idxTelefono]).trim() : "",
                        direccion: idxDireccion !== -1 && rowData[idxDireccion] ? String(rowData[idxDireccion]).trim() : "",
                        colonia: idxColonia !== -1 && rowData[idxColonia] ? String(rowData[idxColonia]).trim() : "",
                        cPostal: idxCp !== -1 && rowData[idxCp] ? String(rowData[idxCp]).trim() : "",
                        ine: idxIne !== -1 && rowData[idxIne] ? String(rowData[idxIne]).trim() : "",
                        numCuarto: idxNumCuarto !== -1 && rowData[idxNumCuarto] ? String(rowData[idxNumCuarto]).trim() : "",
                        estado: "",
                        ciudad: ""
                    };
                    rows.push(item);
                }


                if (rows.length === 0) {
                    mostrarError("No se encontraron registros de pacientes válidos en el archivo.");
                    e.target.value = "";
                    setPacientesExcel([]);
                    setNombreArchivo("");
                } else {
                    setPacientesExcel(rows);
                    Swal.fire({
                        title: "Archivo cargado",
                        text: `Se leyeron correctamente ${rows.length} pacientes del archivo.`,
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                }
            } catch (err) {
                console.error("Error al procesar el archivo Excel:", err);
                mostrarError("Error al procesar el contenido del archivo de Excel. Verifique que no esté dañado.");
                e.target.value = "";
                setPacientesExcel([]);
                setNombreArchivo("");
            } finally {
                setCargandoExcel(false);
            }
        };

        reader.readAsArrayBuffer(file);
    };

    const [empresas, setEmpresas] = useState([]);
    const [empresa, setEmpresa] = useState("");
    const [doctores, setDoctores] = useState([]);
    const [fecha, setFecha] = useState("");
    const [sucursalNombre, setSucursalNombre] = useState("");
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [asignarFecha, setAsignarFecha] = useState(false);
    const [modoEntrega, setModoEntrega] = useState("normal");
    const [fechaGlobal, setFechaGlobal] = useState("");
    const [viewOnlyE, setViewOnlyE] = useState(false);
    const [viewOnlyP, setViewOnlyP] = useState(false);
    const [viewOnlyM, setViewOnlyM] = useState(false);
    const [viewOnlyM2, setViewOnlyM2] = useState(false);
    const [viewOnlyM3, setViewOnlyM3] = useState(false);
    const [viewOnly, setViewOnly] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editModeG, setEditModeG] = useState(false);
    const [editModeM, setEditModeM] = useState(false);
    const [cancelMode, setCancelMode] = useState(false);
    const [showCotizacionPacienteHeader, setShowCotizacionPacienteHeader] =
        useState(false);
    const [cotizacionNumero, setCotizacionNumero] = useState("");
    const [solicitudCodigo, setSolicitudCodigo] = useState("");
    const [solicitudSucursalNombre, setSolicitudSucursalNombre] = useState("");
    const [solicitudFecha, setSolicitudFecha] = useState("");
    const [solicitudInserto, setSolicitudInserto] = useState("");
    const [cotizacionHeader, setCotizacionHeader] = useState(null);
    const [usuario, setUsuario] = useState("");
    const [estudios, setEstudios] = useState([
        {
            cantidad: "1",
            codigo: "",
            nombre: "",
            costo: "",
            tiempoEntrega: "",
            idEstudio: "",
            descuento: "",
            fechaEntrega: "",
            fechaMuestra: getFechaHoy(),
            muestraPendiente: false,
            urgente: false,
        },
    ]);
    const [sucursales, setSucursales] = useState([]);
    const [opcionDescuento, setOpcionDescuento] = useState("ninguno");
    const [estudiosOriginales, setEstudiosOriginales] = useState([]);
    const [valorGeneral, setValorGeneral] = useState("");
    const [estudiosOptions, setEstudiosOptions] = useState([]);
    const [preciosByLista, setPreciosByLista] = useState({});
    const [preciosSucursal, setPreciosSucursal] = useState([]);
    const [notas, setNotas] = useState("");
    const [selectedLista, setSelectedLista] = useState("");
    const [selectedSolicitudId, setSelectedSolicitudId] = useState(null);
    const [solicitudEstatus, setSolicitudEstatus] = useState("S");
    const [solicitudACuenta, setSolicitudACuenta] = useState(0);
    const [solicitudRestante, setSolicitudRestante] = useState(0);
    const [solicitudSaldoPendiente, setSolicitudSaldoPendiente] = useState(0);
    const [totalesCaja, setTotalesCaja] = useState({
        subtotal: 0,
        descuento: 0,
        adeudo: 0,
        total: 0,
        aCuenta: 0,
        restante: 0,
    });
    const [enviarWhatsapp, setEnviarWhatsapp] = useState("seleccione");
    const [enviarEmail, setEnviarEmail] = useState("seleccione");
    const [enviarWhatsappD, setenviarWhatsappD] = useState("seleccione");
    const [enviarEmailD, setenviarEmailD] = useState("seleccione");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const esEstatusSoloLectura = (estatus) => {
        const estatusNormalizado = `${estatus ?? ""}`.trim().toUpperCase();
        return estatusNormalizado === "EN" || estatusNormalizado === "C";
    };

    const aplicarBloqueoPorEstatus = (estatus) => {
        const esSoloLectura = esEstatusSoloLectura(estatus);

        setEditMode(false);
        setEditModeG(false);
        setEditModeM(false);
        setViewOnly(esSoloLectura);
        setViewOnlyE(esSoloLectura);
        setViewOnlyP(esSoloLectura);
        setViewOnlyM(esSoloLectura);
        setViewOnlyM2(esSoloLectura);
        setViewOnlyM3(esSoloLectura);

        return esSoloLectura;
    };
    const [saving, setSaving] = useState({
        nombre: false,
        apPaterno: false,
        apMaterno: false,
        sexo: false,
        fechaNacimiento: false,
        email: false,
        telefono: false,
    });
    const [savingM, setSavingM] = useState({
        nombre: false,
        apPaterno: false,
        apMaterno: false,
        sexo: false,
        fechaNacimiento: false,
        email: false,
        telefono: false,
    });
    const MySwal = withReactContent(Swal);

    const addEstudio = () => {
        setEstudios((prev) => [
            ...prev,
            {
                cantidad: "1",
                codigo: "",
                nombre: "",
                costo: "",
                tiempoEntrega: "",
                idEstudio: "",
                descuento: "",
                fechaEntrega: "",
                fechaMuestra: getFechaHoy(),
                muestraPendiente: false,
            },
        ]);
    };
    const handleRemoveEstudio = (index) => {
        const estatusActual = `${solicitudEstatus ?? ""}`.trim().toUpperCase();
        if (viewOnly || ["P", "PC"].includes(estatusActual)) return;
        setEstudios((prev) => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (selectedPaciente) {
            setNombre(selectedPaciente.nombre || "");
            setApPaterno(selectedPaciente.apPaterno || "");
            setApMaterno(selectedPaciente.apMaterno || "");
            setSexo(selectedPaciente.sexo || "");
            setFechaNac(selectedPaciente.fechaNacimiento || "");
            setEdad(selectedPaciente.edad || "");
            setTelefonoCelular(selectedPaciente.telefonoCelular || "");
            setDireccion(selectedPaciente.direccion || "");
            setColonia(selectedPaciente.colonia || "");
            setCPostal(selectedPaciente.cPostal || "");
            setEstado(selectedPaciente.estado || "");
            setCiudad(selectedPaciente.ciudad);
            setIne(selectedPaciente.ine || "");
            setEmail(selectedPaciente.email || "");
            if (!editMode) {
                setViewOnlyP(true);
            }
        } else {
            setNombre("");
            setApPaterno("");
            setApMaterno("");
            setSexo("");
            setFechaNac("");
            setEdad("");
            setTelefonoCelular("");
            setDireccion("");
            setColonia("");
            setCPostal("");
            setEstado("seleccione");
            setCiudad("");
            setIne("");
            setEmail("");
            setViewOnly(false);
            setViewOnlyP(false);
        }
    }, [selectedPaciente]);

    useEffect(() => {
        if (selectedDoctor) {
            setNombreDoctor(selectedDoctor.nombre || "");
            setApPaternoDoctor(selectedDoctor.apPaterno || "");
            setApMaternoDoctor(selectedDoctor.apMaterno || "");
            setEmailDoctor(selectedDoctor.email || "");
            setTelefonoDoctor(selectedDoctor.telefono || selectedDoctor.telefonoCelular || "");
            setEsComisionD(Boolean(selectedDoctor.esComision || selectedDoctor.conComision || selectedDoctor.comision));
            if (!editModeM) {
                setViewOnlyM(true);
            }
        } else {
            setNombreDoctor("");
            setApPaternoDoctor("");
            setApMaternoDoctor("");
            setEmailDoctor("");
            setTelefonoDoctor("");
            setEsComisionD(false);
        }
    }, [selectedDoctor]);

    useEffect(() => {
        if (selectedDoctor2) {
            setNombreDoctor2(selectedDoctor2.nombre || "");
            setApPaternoDoctor2(selectedDoctor2.apPaterno || "");
            setApMaternoDoctor2(selectedDoctor2.apMaterno || "");
            setEmailDoctor2(selectedDoctor2.email || "");
            setTelefonoDoctor2(selectedDoctor2.telefono || selectedDoctor2.telefonoCelular || "");
            setEsComisionD2(Boolean(selectedDoctor2.esComision || selectedDoctor2.conComision || selectedDoctor2.comision));
            if (!editModeM2) {
                setViewOnlyM2(true);
            }
        } else {
            setNombreDoctor2("");
            setApPaternoDoctor2("");
            setApMaternoDoctor2("");
            setEmailDoctor2("");
            setTelefonoDoctor2("");
            setEsComisionD2(false);
        }
    }, [selectedDoctor2]);

    useEffect(() => {
        if (selectedDoctor3) {
            setNombreDoctor3(selectedDoctor3.nombre || "");
            setApPaternoDoctor3(selectedDoctor3.apPaterno || "");
            setApMaternoDoctor3(selectedDoctor3.apMaterno || "");
            setEmailDoctor3(selectedDoctor3.email || "");
            setTelefonoDoctor3(selectedDoctor3.telefono || selectedDoctor3.telefonoCelular || "");
            setEsComisionD3(Boolean(selectedDoctor3.esComision || selectedDoctor3.conComision || selectedDoctor3.comision));
            if (!editModeM3) {
                setViewOnlyM3(true);
            }
        } else {
            setNombreDoctor3("");
            setApPaternoDoctor3("");
            setApMaternoDoctor3("");
            setEmailDoctor3("");
            setTelefonoDoctor3("");
            setEsComisionD3(false);
        }
    }, [selectedDoctor3]);



    const usuarioString = sessionStorage.getItem("usuario");
    const currentU = JSON.parse(usuarioString);
    const estatusMapHTML = {
        C: { label: "Cancelada", color: "red" },
        S: { label: "Sin pagos", color: "gray" },
        E: { label: "Entregada", color: "green" },
        P: { label: "Pagada", color: "blue" },
        PC: { label: "Pagada parcialmente", color: "gold" }
    };


    async function enrichEstudioSelection(index, selectedValue) {
        if (!selectedValue) {
            setEstudios((prev) => {
                const next = [...prev];
                next[index] = {
                    ...next[index],
                    idEstudio: "",
                    codigo: "",
                    nombre: "",
                    costo: "",
                    tiempoEntrega: "",
                    descuento: "",
                    fechaEntrega: "",
                    fechaMuestra: getFechaHoy(),
                    muestraPendiente: false,
                    muestras: [],
                    estudiosInt: [],
                };
                return next;
            });
            return;
        }

        const id = selectedValue.idEstudio || "";
        const codigo = selectedValue.codigo || "";
        const nombre = selectedValue.nombre || "";

        let listaId = "";
        if (selectedEmpresa?.idListaPrecio) {
            listaId = selectedEmpresa.idListaPrecio;
        } else {
            listaId = await obtenerListaPrecioVigente();

        }

        if (!listaId) {
            mostrarError(
                "No existe una lista de precios vigente para la sucursal actual",
            );
            return;
        }


        const nombreL = preciosByLista?.[listaId]?.nombre ?? "Lista desconocida";
        setSelectedLista(nombreL);

        const costo =
            listaId &&
                preciosByLista[listaId] &&
                preciosByLista[listaId].precios[id] !== undefined
                ? preciosByLista[listaId].precios[id]
                : "";

        const getEstudioIntId = (estInt) =>
            String(estInt.idEstudioSec ?? estInt.idEstudio ?? estInt.idEstudioPrin ?? "");

        const existeEnOtraFila = estudios.some((e, idxItem) =>
            idxItem !== index &&
            (String(e.idEstudio) === String(id) ||
                (e.estudiosInt || []).some(
                    (estInt) => getEstudioIntId(estInt) === String(id),
                )),
        );
        if (existeEnOtraFila) {
            mostrarError(
                "No se puede agregar porque este estudio ya está en la solicitud o ya forma parte de un estudio integrado.",
            );
            return;
        }

        try {
            const [estudioDetalle, muestras, estudiosInt] = await Promise.all([
                EstudiosService.getEstudioPorId(id),
                MuestrasService.getMuestrasPorEstudio(id),
                EstudiosIntService.getEstudiosPorEstudio(id),
            ]);

            const estudiosIntIds = new Set(
                (estudiosInt || []).map((intEstudio) => getEstudioIntId(intEstudio)),
            );

            const yaExiste = estudios.some((e, idxItem) =>
                idxItem !== index && String(e.idEstudio) === String(id),
            );
            if (yaExiste) {
                mostrarError("El estudio ya está agregado");
                return;
            }

            const yaIncluidoComoIntegrado = estudios.some((e) =>
                (e.estudiosInt || []).some((intEstudio) =>
                    getEstudioIntId(intEstudio) === String(id),
                ),
            );
            if (yaIncluidoComoIntegrado) {
                mostrarError(
                    "No se puede agregar este estudio porque ya forma parte de un estudio integrado ya agregado.",
                );
                return;
            }

            const algunoIntegradoYaAgregado = estudios.some((e) =>
                String(e.idEstudio) !== String(id) &&
                estudiosIntIds.has(String(e.idEstudio)),
            );
            if (algunoIntegradoYaAgregado) {
                mostrarError(
                    "No se puede agregar este estudio porque uno de sus estudios integrados ya está en la solicitud.",
                );
                return;
            }

            const tiempoEntrega = estudioDetalle?.tiempoEntrega ?? "";
            const fechaEntrega = calcularFechaEntrega(tiempoEntrega);

            const muestrasConIndicaciones = (muestras || []).filter(
                (m) => m.indicacionesToma && m.indicacionesToma.trim() !== ""
            );

            if (muestrasConIndicaciones.length > 0) {
                const htmlContent = `
          <div style="text-align:left; font-size:1vw; font-family: Roboto-Regular; color: #333;">
            <p style="margin-bottom: 1.5vh; font-size: 1.1vw; font-weight: bold; color: #18234f;">
              El estudio <strong>"${nombre}"</strong> requiere las siguientes indicaciones de toma:
            </p>
            <div style="max-height: 40vh; overflow-y: auto; padding-right: 0.5vw;">
              ${muestrasConIndicaciones
                        .map(
                            (m) => `
                <div style="margin-bottom: 1.5vh; padding: 1vw; border-radius: 8px; border-left: 5px solid #e08505; background-color: #fcf8f2;">
                  <div style="font-weight: bold; color: #e08505; font-size: 0.95vw; margin-bottom: 0.5vh;">
                    Muestra: ${m.tipoMuestra || "No especificado"} (${m.nombreMaterial || "Material no especificado"})
                  </div>
                  <div style="font-size: 0.9vw; line-height: 1.4; color: #555;">
                    ${m.indicacionesToma}
                  </div>
                </div>
              `
                        )
                        .join("")}
            </div>
          </div>
        `;

                await Swal.fire({
                    title: "INDICACIONES DE TOMA DE MUESTRA",
                    html: htmlContent,
                    icon: "warning",
                    width: "50%",
                    confirmButtonText: "He leído las indicaciones de toma",
                    confirmButtonColor: "#2e7d32",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        title: "tituloDegradado",
                        popup: "swalMaxHeight",
                    },
                });
            }

            setEstudios((prev) => {
                const next = [...prev];
                next[index] = {
                    ...next[index],
                    idEstudio: id,
                    codigo,
                    nombre,
                    costo,
                    descuento: "",
                    tiempoEntrega,
                    fechaEntrega,
                    fechaMuestra: getFechaHoy(),
                    muestraPendiente: false,
                    muestras: muestras || [],
                    estudiosInt: estudiosInt || [],
                };

                if (index === prev.length - 1) {
                    next.push({
                        cantidad: "1",
                        codigo: "",
                        nombre: "",
                        costo: "",
                        idEstudio: "",
                        descuento: "",
                        tiempoEntrega: "",
                        fechaEntrega: "",
                        fechaMuestra: getFechaHoy(),
                        muestraPendiente: false,
                        muestras: [],
                        estudiosInt: [],
                    });
                }

                return next;
            });
        } catch (err) {
            console.error(err);
        }
    }

    const parseNumero = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    };

    const tieneDescuentoPorEstudio = (items = estudios) =>
        items.some((estudio) => {
            const descuento = estudio?.descuento;
            return descuento !== "" && descuento !== null && descuento !== undefined;
        });

    const calcularSubtotal = (items = estudios) =>
        items.reduce((acc, estudio) => {
            const cantidad = parseNumero(estudio?.cantidad || 0);
            const costo = parseNumero(estudio?.costo || 0);
            return acc + cantidad * costo;
        }, 0);

    const calcularDescuentoTotalLocal = (items = estudios) => {
        const usaDescuentoPorEstudio = tieneDescuentoPorEstudio(items);

        if (opcionDescuento === "porcentaje") {
            if (!usaDescuentoPorEstudio && valorGeneral !== "" && valorGeneral !== null) {
                const porcentaje = parseNumero(valorGeneral);
                if (porcentaje > 100) {
                    mostrarError("El porcentaje no puede ser mayor a 100%");
                    setValorGeneral("");
                    return 0;
                }

                if (porcentaje > 0) {
                    return calcularSubtotal(items) * (porcentaje / 100);
                }
            }

            return items.reduce((acc, estudio) => {
                const porcentaje = parseNumero(estudio?.descuento || 0);
                const cantidad = parseNumero(estudio?.cantidad || 0);
                const costo = parseNumero(estudio?.costo || 0);
                return acc + cantidad * costo * (porcentaje / 100);
            }, 0);
        }

        if (opcionDescuento === "cantidad") {
            if (!usaDescuentoPorEstudio && valorGeneral !== "" && valorGeneral !== null) {
                const descuento = parseNumero(valorGeneral);
                if (descuento > 0) {
                    return descuento;
                }
            }

            return items.reduce((acc, estudio) => acc + parseNumero(estudio?.descuento || 0), 0);
        }

        return 0;
    };

    const obtenerDatosCaja = (respuestaCaja) => {
        if (!respuestaCaja) return null;

        const payload = respuestaCaja?.data ?? respuestaCaja;
        const items = Array.isArray(payload?.caja)
            ? payload.caja
            : Array.isArray(payload)
                ? payload
                : [];

        const item = items[0] ?? payload?.caja?.[0] ?? payload?.[0] ?? payload;
        return item && typeof item === "object" ? item : null;
    };

    const normalizarTotalesCaja = (respuestaCaja) => {
        const datosCaja = obtenerDatosCaja(respuestaCaja);
        const subtotal = parseNumero(
            datosCaja?.subtotal ??
            datosCaja?.subtotalCaja ??
            datosCaja?.total ??
            datosCaja?.totalSolicitud ??
            datosCaja?.importe ??
            datosCaja?.monto ??
            0,
        );
        const descuento = parseNumero(
            datosCaja?.descuento ??
            datosCaja?.descuentoTotal ??
            datosCaja?.descuentoSolicitud ??
            0,
        );
        const iva = parseNumero(
            datosCaja?.iva ??
            datosCaja?.ivaTotal ??
            datosCaja?.montoIva ??
            0,
        );
        const adeudo = parseNumero(
            datosCaja?.adeudo ??
            datosCaja?.saldoPendiente ??
            datosCaja?.restante ??
            datosCaja?.saldo ??
            datosCaja?.pendiente ??
            datosCaja?.deuda ??
            0,
        );
        const aCuentaExplicito = parseNumero(
            datosCaja?.aCuenta ??
            datosCaja?.pagado ??
            datosCaja?.montoPagado ??
            datosCaja?.totalPagado ??
            datosCaja?.pagos ??
            datosCaja?.importePagado ??
            datosCaja?.pagadoSolicitud ??
            datosCaja?.abono ??
            datosCaja?.abonos ??
            0,
        );

        const total = Math.max(0, subtotal - descuento + iva);
        const aCuenta =
            aCuentaExplicito > 0
                ? aCuentaExplicito
                : (adeudo > 0 ? Math.max(0, total - adeudo) : Math.max(0, total));
        const restante = adeudo > 0 ? adeudo : Math.max(0, total - aCuenta);

        return {
            subtotal,
            descuento,
            iva,
            adeudo,
            total,
            aCuenta,
            restante,
        };
    };

    const actualizarTotalesCaja = async (solicitudId) => {
        if (!solicitudId) return;

        try {
            const cajaRespuesta = await CajaService.getCajaPorSolicitud(solicitudId);
            const cajaTotales = normalizarTotalesCaja(cajaRespuesta);
            setTotalesCaja(cajaTotales);
            setSolicitudACuenta(cajaTotales.aCuenta);
            setSolicitudRestante(cajaTotales.restante);
            setSolicitudSaldoPendiente(cajaTotales.restante);
        } catch (error) {
            console.error("Error actualizando totales de caja:", error);
        }
    };

    const subtotalSolicitud = calcularSubtotal();
    const descuentoTotal = calcularDescuentoTotalLocal();
    const baseResumen = Math.max(0, subtotalSolicitud - descuentoTotal);
    const ivaResumen = requiereFactura ? baseResumen * 0.16 : 0;
    const totalResumen = baseResumen + ivaResumen;

    const subtotalResumen = subtotalSolicitud;
    const descuentoResumen = descuentoTotal;
    const totalSolicitud = totalResumen;
    const ivaSolicitud = ivaResumen;

    const showExtendedTotals = viewOnly || editModeG || editMode || editModeM;
    const showEstadoRow = showExtendedTotals;
    const esSolicitudPagada = ["P", "E"].includes(`${solicitudEstatus ?? ""}`.trim().toUpperCase());

    const pagadoResumen = Number(totalesCaja?.aCuenta) || parseNumero(solicitudACuenta) || 0;
    const adeudoResumen = showExtendedTotals
        ? Math.max(0, totalResumen - pagadoResumen)
        : 0;
    const porcentajeEquivalente =
        opcionDescuento === "porcentaje" && subtotalSolicitud > 0
            ? ((descuentoTotal / subtotalSolicitud) * 100).toFixed(2)
            : "";

    const solicitudEstatusLabel =
        estatusMapHTML[solicitudEstatus]?.label || solicitudEstatus || "";
    const aCuentaMonto = showExtendedTotals ? Math.max(pagadoResumen, parseNumero(solicitudACuenta)) : 0;
    const restanteMonto = showExtendedTotals ? Math.max(0, totalResumen - aCuentaMonto) : 0;
    const saldoPendienteMonto = restanteMonto;

    const valorGeneralMostrado =
        opcionDescuento === "ninguno"
            ? ""
            : tieneDescuentoPorEstudio()
                ? porcentajeEquivalente
                : valorGeneral;

    const showFechaMuestraColumn = viewOnly || editModeG || editMode || editModeM;

    const validarDescuentosFormulario = (
        opcionDesc = opcionDescuento,
        valGen = valorGeneral,
        listaEstudios = estudios,
        totPagado = pagadoResumen
    ) => {
        if (opcionDesc === "ninguno") {
            return { esValido: true, errorGeneral: "", erroresEstudios: new Array(listaEstudios.length).fill("") };
        }

        const subtotalBruto = calcularSubtotal(listaEstudios);
        const factorIva = requiereFactura ? 1.16 : 1.0;

        let errGeneral = "";
        const errEstudios = new Array(listaEstudios.length).fill("");

        if (opcionDesc === "porcentaje") {
            if (valGen !== "" && valGen !== null && valGen !== undefined) {
                const pctVal = parseNumero(valGen);
                if (pctVal > 100) {
                    errGeneral = "El descuento en porcentaje no puede ser mayor a 100%.";
                } else if (totPagado > 0 && pctVal > 0) {
                    const totalBrutoSinDesc = subtotalBruto * factorIva;
                    const maxDescBaseGen = Math.max(0, subtotalBruto - (totPagado / factorIva));
                    const montoDescSubtotal = subtotalBruto * (pctVal / 100);

                    if (montoDescSubtotal > maxDescBaseGen + 0.001) {
                        errGeneral = `El descuento no puede superar la deuda restante.`;
                    }
                }
            }

            listaEstudios.forEach((est, idx) => {
                if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
                    const pctEst = parseNumero(est.descuento);
                    if (pctEst > 100) {
                        errEstudios[idx] = "El descuento en porcentaje no puede ser mayor a 100%.";
                    }
                }
            });

            if (totPagado > 0) {
                listaEstudios.forEach((est, idx) => {
                    if (errEstudios[idx]) return;
                    const descEst = parseNumero(est?.descuento);
                    if (descEst <= 0) return;

                    const otrosDescuentos = listaEstudios.reduce((acc, item, itemIdx) => {
                        if (itemIdx === idx) return acc;
                        const pct = parseNumero(item?.descuento || 0);
                        const cant = parseNumero(item?.cantidad || 1);
                        const cst = parseNumero(item?.costo || 0);
                        return acc + (cant * cst * (pct / 100));
                    }, 0);

                    const subtotalBaseOtros = Math.max(0, subtotalBruto - otrosDescuentos);
                    const maxDescBaseEsteEstudio = Math.max(0, subtotalBaseOtros - (totPagado / factorIva));
                    const cantEst = parseNumero(est?.cantidad || 1);
                    const cstEst = parseNumero(est?.costo || 0);
                    const montoDescEsteEstudio = (cantEst * cstEst) * (descEst / 100);

                    if (montoDescEsteEstudio > maxDescBaseEsteEstudio + 0.001) {
                        errEstudios[idx] = `El descuento no puede superar la deuda restante.`;
                    }
                });
            }
        } else if (opcionDesc === "cantidad") {
            if (valGen !== "" && valGen !== null && valGen !== undefined) {
                const montoVal = parseNumero(valGen);
                if (montoVal > subtotalBruto) {
                    errGeneral = "El descuento no puede ser mayor al total de la solicitud.";
                } else if (totPagado > 0 && montoVal > 0) {
                    const maxDescBaseGen = Math.max(0, subtotalBruto - (totPagado / factorIva));

                    if (montoVal > maxDescBaseGen + 0.001) {
                        errGeneral = `El descuento no puede superar la deuda restante.`;
                    }
                }
            }

            listaEstudios.forEach((est, idx) => {
                if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
                    const montoEst = parseNumero(est.descuento);
                    const costoEst = parseNumero(est.costo) * parseNumero(est.cantidad || 1);
                    if (montoEst > costoEst) {
                        errEstudios[idx] = "El descuento no puede ser mayor al total del estudio.";
                    }
                }
            });

            if (totPagado > 0) {
                listaEstudios.forEach((est, idx) => {
                    if (errEstudios[idx]) return;
                    const montoEst = parseNumero(est?.descuento);
                    if (montoEst <= 0) return;

                    const otrosDescuentos = listaEstudios.reduce((acc, item, itemIdx) => {
                        if (itemIdx === idx) return acc;
                        return acc + parseNumero(item?.descuento || 0);
                    }, 0);

                    const subtotalBaseOtros = Math.max(0, subtotalBruto - otrosDescuentos);
                    const maxDescBaseEsteEstudio = Math.max(0, subtotalBaseOtros - (totPagado / factorIva));

                    if (montoEst > maxDescBaseEsteEstudio + 0.001) {
                        errEstudios[idx] = `El descuento no puede superar la deuda restante.`;
                    }
                });
            }
        }

        return {
            esValido: !errGeneral && !errEstudios.some(Boolean),
            errorGeneral: errGeneral,
            erroresEstudios: errEstudios,
        };
    };

    useEffect(() => {
        const resVal = validarDescuentosFormulario(opcionDescuento, valorGeneral, estudios, pagadoResumen);
        setErrorDescuentoGeneral(resVal.errorGeneral);
        setErroresDescuentoEstudios(resVal.erroresEstudios);
    }, [opcionDescuento, valorGeneral, estudios, totalesCaja, solicitudACuenta, requiereFactura]);

    const handleChangeEstudio = (index, field, value) => {
        if (opcionDescuento === "porcentaje" && field === "descuento" && parseNumero(value) > 100) {
            mostrarError("El descuento en porcentaje no puede ser mayor a 100%.");
        }

        const valorNormalizado = ["fechaMuestra", "fechaEntrega"].includes(field)
            ? formatDateForBackend(value)
            : value;

        if (field === "fechaEntrega" && modoEntrega === "asignarFecha") {
            setFechaGlobal("");
            setEstudios((prev) =>
                prev.map((estudio, idx) =>
                    idx === index
                        ? {
                            ...estudio,
                            fechaEntrega: valorNormalizado,
                            urgente: true,
                        }
                        : estudio,
                ),
            );
            return;
        }

        const nuevosEstudios = [...estudios];
        const estudioAnterior = estudios[index] || {};
        nuevosEstudios[index] = {
            ...estudioAnterior,
            [field]: valorNormalizado,
        };
        setEstudios(nuevosEstudios);

        // Si se cambió el descuento y hay un modo de descuento activo, actualizar valores relacionados
        if (field === "descuento" && opcionDescuento !== "ninguno") {
            if (opcionDescuento === "porcentaje") {
                const tieneDescuento = nuevosEstudios.some(
                    (estudio) => estudio.descuento !== "" && estudio.descuento !== null,
                );
                if (tieneDescuento) {
                    const subtotal = calcularSubtotal(nuevosEstudios);
                    const totalDescuento = calcularDescuentoTotalLocal(nuevosEstudios);
                    const porcentajeEquivalente =
                        subtotal > 0 ? ((totalDescuento / subtotal) * 100).toFixed(2) : "";
                    setValorGeneral(porcentajeEquivalente);
                } else {
                    setValorGeneral("");
                }
            } else if (opcionDescuento === "cantidad") {
                setValorGeneral("");
            }
        }
    };

    const getFechaEntregaNormal = (estudio) =>
        estudio?.idEstudio ? calcularFechaEntrega(estudio.tiempoEntrega) : "";

    const handleChangeValorGeneral = (value) => {
        setValorGeneral(value);

        let nuevosEstudios = estudios;
        if (opcionDescuento === "porcentaje") {
            nuevosEstudios = estudios.map((estudio) => ({
                ...estudio,
                descuento: "",
            }));
            setEstudios(nuevosEstudios);
        }

        const resVal = validarDescuentosFormulario(opcionDescuento, value, nuevosEstudios, pagadoResumen);
        setErrorDescuentoGeneral(resVal.errorGeneral);
        setErroresDescuentoEstudios(resVal.erroresEstudios);
    };

    const handleChangeOpcionDescuento = (value) => {
        setOpcionDescuento(value);
        setValorGeneral("");
        setErrorDescuentoGeneral("");
        setErroresDescuentoEstudios(new Array(estudios.length).fill(""));
        setEstudios((prev) =>
            prev.map((estudio) => ({
                ...estudio,
                descuento: "",
            })),
        );
    };

    const cargarCotizacionEnFormulario = async (numeroCotizacion) => {
        const valor = `${numeroCotizacion ?? ""}`.trim();
        if (!valor) {
            return;
        }

        try {
            const respuesta = await CotizacionesService.getCotizacionIndividual(valor);
            const cotizacion = respuesta?.cotizacion?.[0] || respuesta?.cotizacion || null;

            if (!cotizacion) {
                mostrarError(`No existe una cotización con el número ${valor}.`);
                setCotizacionHeader(null);
                setCotizacionNumero(valor);
                return;
            }

            setCotizacionHeader(cotizacion);
            setCotizacionNumero(String(cotizacion.idCotizacion ?? valor));
            setFecha(cotizacion.fecha || getFechaHoy());
            setShowCotizacionPacienteHeader(false);
            setSelectedDoctor(null);
            setNombreDoctor("");
            setApPaternoDoctor("");
            setApMaternoDoctor("");
            setEmailDoctor("");
            setTelefonoDoctor("");

            let empresaCompleta = null;
            if (cotizacion.idConvenio) {
                const convenioResp = await ConveniosService.getConvenioPorId(
                    cotizacion.idConvenio,
                );
                empresaCompleta = convenioResp?.convenio?.[0] || convenioResp?.convenio || null;
            }
            await actualizarListaPreciosParaConvenio(empresaCompleta);

            if (cotizacion.idPaciente) {
                const pacienteResp = await PacientesService.getPacientePorId(
                    cotizacion.idPaciente,
                );
                const pacienteCompleto = pacienteResp?.paciente?.[0] || pacienteResp?.paciente || null;
                if (pacienteCompleto) {
                    setSelectedPaciente(pacienteCompleto);
                    setNombre(pacienteCompleto.nombre || "");
                    setApPaterno(pacienteCompleto.apPaterno || "");
                    setApMaterno(pacienteCompleto.apMaterno || "");
                    setSexo(pacienteCompleto.sexo || "");
                    setFechaNac(pacienteCompleto.fechaNacimiento || "");
                    setEdad(pacienteCompleto.edad || "");
                    setEmail(pacienteCompleto.email || "");
                    setTelefonoCelular(pacienteCompleto.telefonoCelular || "");
                    setDireccion(pacienteCompleto.direccion || "");
                    setColonia(pacienteCompleto.colonia || "");
                    setCPostal(pacienteCompleto.cPostal || "");
                    setEstado(pacienteCompleto.estado || "seleccione");
                    setCiudad(pacienteCompleto.ciudad || "");
                    setIne(pacienteCompleto.ine || "");
                } else {
                    setSelectedPaciente(null);
                }
            } else {
                setSelectedPaciente(null);
            }

            const respuestaEstudios = await CotizacionesEstudiosService.getEstudiosPorCotizacion(
                cotizacion.idCotizacion,
            );
            const estudiosCotizacion = respuestaEstudios?.estudios || [];
            const estudiosConDetalles = await Promise.all(
                estudiosCotizacion.map(async (estudio) => {
                    const estudioPorId = await EstudiosService.getEstudioPorId(
                        estudio.idEstudio,
                    );
                    const [muestras, estudiosInt] = await Promise.all([
                        MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
                        EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
                    ]);

                    return {
                        ...estudio,
                        codigo: estudioPorId?.codigo || "",
                        nombre: estudioPorId?.nombre || "",
                        costo: estudio.costo ?? estudioPorId?.costo ?? "",
                        tiempoEntrega: estudioPorId?.tiempoEntrega || "",
                        descuento: estudio.descuento ?? "",
                        fechaEntrega: formatDateForBackend(estudio.fechaEntrega || calcularFechaEntrega(estudioPorId?.tiempoEntrega || "")),
                        fechaMuestra:
                            estudio.fechaMuestra === "PENDIENTE"
                                ? "PENDIENTE"
                                : formatDateForBackend(estudio.fechaMuestra || getFechaHoy()),
                        muestraPendiente:
                            normalizarBooleano(estudio.muestraPendiente) ||
                            `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
                        urgente: estudio.urgente,
                        muestras: muestras || [],
                        estudiosInt: estudiosInt || [],
                    };
                }),
            );

            setEstudios(
                estudiosConDetalles.length > 0
                    ? estudiosConDetalles
                    : [
                        {
                            cantidad: "1",
                            codigo: "",
                            nombre: "",
                            costo: "",
                            tiempoEntrega: "",
                            idEstudio: "",
                            descuento: "",
                            fechaEntrega: "",
                            fechaMuestra: getFechaHoy(),
                            muestraPendiente: false,
                        },
                    ],
            );
            setNotas(cotizacion.observaciones || "");
            setValorGeneral(cotizacion.descuentoTotal ?? "");
            setOpcionDescuento(cotizacion.tipoDescuento || "ninguno");
            setMotivoDescuento(cotizacion.motivoDescuento || "");
        } catch (error) {
            console.error(error);
            mostrarError("No se pudo cargar la cotización. Intenta de nuevo.");
        }
    };






    async function mostrarInfo(estudio) {
        Swal.fire({
            title: "DETALLE DEL ESTUDIO",
            width: "55%",
            customClass: {
                title: "tituloDegradado",
                popup: "swalMaxHeight",
                confirmButton: "btnConfirmBlueInfo",
            },
            html: `
      <div style="text-align:left; font-size:0.9rem;">
        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">DATOS PRINCIPALES</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Nombre:</b></td><td>${estudio.nombre}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega:</b></td><td>${estudio.tiempoEntrega || ""} Días</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega urgente:</b></td><td>${estudio.tiempoProceso || ""} ${estudio.tiempoProcesoDH || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Condiciones del paciente:</b></td><td>${estudio.condicionesPaciente || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Descripción científica:</b></td><td>${estudio.descripcionCien || ""}</td></tr>
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">MUESTRAS DEL ESTUDIO</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          ${estudio.muestras
                    .map(
                        (m) => `
            <tr><td style="background-color:#172149; color:white;><b>Tubo o Material:</b></td><td>${m.nombreMaterial}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Tipo de muestra:</b></td><td>${m.tipoMuestra}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones para la toma:</b></td><td>${m.indicacionesToma}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones de estabilidad:</b></td><td>${m.indicacionesEstabilidad}</td></tr>
          `,
                    )
                    .join("")}
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">ESTUDIOS QUE LO INTEGRAN</div>
        <ul style="margin-left:1em;">
          ${estudio.estudiosInt.map((i) => `<li><b>${i.nombre}</b></li>`).join("")}
        </ul>
      </div>
    `,
            confirmButtonText: `
    <span style="display:flex; align-items:center; gap:0.5vw;">
      Regresar
    </span>
  `,
        });
    }

    const actualizarListaPreciosParaConvenio = async (value) => {
        const empresaSeleccionada = value || null;
        setSelectedEmpresa(empresaSeleccionada);

        if (empresaSeleccionada) {
            setEmpresa(empresaSeleccionada.nombre || "");
            setViewOnlyE(true);
        } else {
            setEmpresa("");
            setViewOnlyE(false);
        }

        let nuevaListaId = "";
        if (empresaSeleccionada?.idListaPrecio) {
            nuevaListaId = empresaSeleccionada.idListaPrecio;
        } else {
            nuevaListaId = await obtenerListaPrecioVigente();
        }

        if (!nuevaListaId) {
            mostrarError(
                "No existe una lista de precios vigente para la sucursal actual",
            );
            return "";
        }

        const nombreL = preciosByLista?.[nuevaListaId]?.nombre ?? "Lista de la sucursal";
        setSelectedLista(nombreL);

        if (nuevaListaId) {
            setEstudios((prevEstudios) =>
                prevEstudios.map((estudio) => {
                    if (!estudio.idEstudio) return estudio;
                    const listaPreciosObj = preciosByLista[nuevaListaId];
                    const nuevoCosto =
                        listaPreciosObj &&
                            listaPreciosObj.precios &&
                            listaPreciosObj.precios[estudio.idEstudio] !== undefined
                            ? listaPreciosObj.precios[estudio.idEstudio]
                            : "";
                    return {
                        ...estudio,
                        costo: nuevoCosto,
                    };
                }),
            );
        }

        return nuevaListaId;
    };

    async function changeEmpresa() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        setEmpresa("");
        setSelectedEmpresa(null);
        setViewOnlyE(false);
        await actualizarListaPreciosParaConvenio(null);
    }

    function changeEditMode() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        if (selectedPaciente) {
            setEditMode(true);
            setViewOnly(false);
            setViewOnlyP(false)
        }
    }

    function changeEditModeM() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        if (selectedDoctor) {
            setEditModeM(true);
            setViewOnly(false);
            setViewOnlyM(false)
        }
    }

    function changePaciente() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        setEditMode(false);
        setViewOnly(false);
        setViewOnlyP(false)
        setShowCotizacionPacienteHeader(false);
        setNombre("");
        setApPaterno("");
        setApMaterno("");
        setSexo("");
        setFechaNac("");
        setEdad("");
        setTelefonoCelular("");
        setDireccion("");
        setColonia("");
        setCPostal("");
        setEstado("seleccione");
        setCiudad("");
        setIne("");
        setEmail("");
    }

    function changeDoctor() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        setSelectedDoctor(null);
        setEditModeM(false);
        setViewOnlyM(false);
        setNombreDoctor("");
        setApPaternoDoctor("");
        setApMaternoDoctor("");
        setEmailDoctor("");
        setTelefonoDoctor("");
        setEsComisionD(false);
    }

    function changeDoctor2() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        setSelectedDoctor2(null);
        setEditModeM2(false);
        setViewOnlyM2(false);
        setNombreDoctor2("");
        setApPaternoDoctor2("");
        setApMaternoDoctor2("");
        setEmailDoctor2("");
        setTelefonoDoctor2("");
        setEsComisionD2(false);
    }

    function changeDoctor3() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        setSelectedDoctor3(null);
        setEditModeM3(false);
        setViewOnlyM3(false);
        setNombreDoctor3("");
        setApPaternoDoctor3("");
        setApMaternoDoctor3("");
        setEmailDoctor3("");
        setTelefonoDoctor3("");
        setEsComisionD3(false);
    }

    function changeEditModeM2() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        if (selectedDoctor2) {
            setEditModeM2(true);
            setViewOnlyM2(false);
        }
    }

    function changeEditModeM3() {
        if (esEstatusSoloLectura(solicitudEstatus)) return;
        if (selectedDoctor3) {
            setEditModeM3(true);
            setViewOnlyM3(false);
        }
    }

    const obtenerListaPrecioVigente = async () => {
        const sucursalId = currentU?.sucursal;
        if (!sucursalId) return "";

        let configuraciones = Array.isArray(preciosSucursal) ? preciosSucursal : [];
        if (!configuraciones.length) {
            try {
                const response =
                    await PreciosSucursalService.getPreciosSucursalPorSucursal(
                        sucursalId,
                    );
                const data = Array.isArray(response?.precios)
                    ? response.precios
                    : [];
                configuraciones = data;

                setPreciosSucursal(data);
            } catch (err) {
                console.error(err);
                return "";
            }
        }

        const configuracionesSucursal = configuraciones.filter((item) => {
            const idSucursal = item?.idSucursal ?? item?.sucursal;
            return String(idSucursal) === String(sucursalId);
        });

        if (!configuracionesSucursal.length) {
            return "";
        }

        const predeterminada = configuracionesSucursal.find((item) => {
            return normalizarBooleano(item?.predCotizacion);
        });
        if (predeterminada) {
            return predeterminada.idListaPrecio || "";
        }

        const diaActual = getDiaActual();
        const horaActual = parseHora(
            new Date().toLocaleTimeString("en-GB", { hour12: false }),
        );

        // Se valida aquí si la configuración coincide con el día actual y con el rango de hora actual.
        const vigente = configuracionesSucursal.find((item) => {
            const mismoDia = cumpleDia(item?.dias, diaActual);
            if (!mismoDia) return false;

            const desde = parseHora(item?.horaInicio);
            const hasta = parseHora(item?.horaFin);
            if (desde === null || hasta === null) return false;

            return horaActual !== null && horaActual >= desde && horaActual <= hasta;
        });

        if (vigente) {
            return vigente.idListaPrecio || "";
        }

        // Si no coincide con el rango horario, se intenta usar una configuración del mismo día aunque no tenga horario definido.
        const sinHorario = configuracionesSucursal.find((item) => {
            if (!cumpleDia(item?.dias, diaActual)) return false;
            const desde = parseHora(item?.horaInicio);
            const hasta = parseHora(item?.horaFin);
            return desde === null || hasta === null;
        });

        return sinHorario?.idListaPrecio || "";
    };

    async function saveField(fieldName, value) {
        if (!selectedPaciente?.idPaciente) {
            setSnackbar({
                open: true,
                message: "Selecciona un paciente antes de guardar.",
                severity: "warning",
            });
            return;
        }
        setSaving((prev) => ({ ...prev, [fieldName]: true }));
        try {
            const payload = { campoN: [fieldName], valorN: value };
            const res = await PacientesService.patchPaciente(
                payload,
                selectedPaciente.idPaciente,
            );
            if (res.data.estatus !== "OK") throw new Error("Error al guardar");
            const updated = res.data.paciente[0];
            setSelectedPaciente((prev) => ({ ...prev, ...updated }));
            setSnackbar({
                open: true,
                message: "Cambios guardados",
                severity: "success",
            });
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: "No se pudo guardar. Intenta de nuevo.",
                severity: "error",
            });
        } finally {
            setSaving((prev) => ({ ...prev, [fieldName]: false }));
        }
    }

    const registrarMovimientoSolicitud = async (tipoAccion, descripcion = "", targetId = null) => {
        try {
            const solId = targetId || selectedSolicitudId;
            if (!solId) return;
            await HistorialEstudiosService.registrarMovimiento({
                idSolicitud: solId,
                idUsuario: currentU?.id || 1,
                tipoAccion,
                descripcion,
            });
        } catch (e) {
            console.error("Error al registrar movimiento:", e);
        }
    };

    async function saveFieldM(fieldName, value, docNum = 1) {
        let targetDoc = selectedDoctor;
        let setTargetDoc = setSelectedDoctor;
        if (docNum === 2) {
            targetDoc = selectedDoctor2;
            setTargetDoc = setSelectedDoctor2;
        } else if (docNum === 3) {
            targetDoc = selectedDoctor3;
            setTargetDoc = setSelectedDoctor3;
        }

        if (!targetDoc?.idDoctor) {
            return;
        }
        const fieldLabelsM = { nombre: "Nombre", apPaterno: "Apellido Paterno", apMaterno: "Apellido Materno", telefonoCelular: "Teléfono", email: "Email", conComision: "Doctor con comisión" };
        const valorAnteriorM = targetDoc?.[fieldName] ?? "";
        setSavingM((prev) => ({ ...prev, [fieldName]: true }));
        try {
            const payload = { campoN: [fieldName], valorN: value };
            const res = await DoctoresService.patchDoctor(
                payload,
                targetDoc.idDoctor,
            );

            if (res.data?.estatus === "OK" || res.status === 200) {
                const updated = res.data?.doctores?.[0] || res.data?.doctor?.[0];
                if (updated) {
                    setTargetDoc((prev) => ({ ...prev, ...updated }));
                } else {
                    setTargetDoc((prev) => ({ ...prev, [fieldName]: value, esComision: Boolean(value), conComision: Boolean(value) }));
                }
                setSnackbar({
                    open: true,
                    message: "Cambios guardados",
                    severity: "success",
                });
                const docLabel = docNum === 1 ? "médico" : `médico ${docNum}`;
                const labelM = fieldLabelsM[fieldName] || fieldName;
                registrarMovimientoSolicitud("EDM", `${labelM} anterior del ${docLabel}: ${valorAnteriorM ?? "(vacío)"} a ${labelM}: ${value}`);
                try {
                    getDoctores();
                } catch (e) { }
            }
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: "No se pudo guardar. Intenta de nuevo.",
                severity: "error",
            });
        } finally {
            setSavingM((prev) => ({ ...prev, [fieldName]: false }));
        }
    }

    const isEstudioEmpty = (estudio) => {
        const codigo = estudio.codigo ?? "";
        const nombre = estudio.nombre ?? "";
        const idEstudio = estudio.idEstudio ?? "";
        return (
            codigo.toString().trim() === "" &&
            nombre.toString().trim() === "" &&
            idEstudio.toString().trim() === ""
        );
    };

    const removeAllEmpty = (arr) => arr.filter((s) => !isEstudioEmpty(s));
    const tieneUnoConDatos = (arr) => arr.some((s) => !isEstudioEmpty(s));
    function getFormattedNow() {
        const now = new Date();

        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0"); // meses 0-11
        const yyyy = now.getFullYear();

        const hours = String(now.getHours()).padStart(2, "0"); // 0-23
        const minutes = String(now.getMinutes()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd} ${hours}:${minutes}`;
    }

    function getFechaHoy() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    }

    const formatDateForBackend = (value) => {
        if (value === null || value === undefined || value === "") return "";

        if (typeof value === "string") {
            const trimmedValue = value.trim();
            if (!trimmedValue) return "";
            if (trimmedValue.toUpperCase() === "PENDIENTE") return "PENDIENTE";
            if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) return trimmedValue;
            if (/^\d{4}-\d{2}-\d{2}[T ][0-9:.]+/.test(trimmedValue)) return trimmedValue.slice(0, 10);
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(trimmedValue)) return trimmedValue.slice(0, 10);

            const ddMmYyyyMatch = trimmedValue.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
            if (ddMmYyyyMatch) {
                const [, day, month, year] = ddMmYyyyMatch;
                return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            }

            const parsedDate = new Date(trimmedValue);
            if (!Number.isNaN(parsedDate.getTime())) {
                const yyyy = parsedDate.getUTCFullYear();
                const mm = String(parsedDate.getUTCMonth() + 1).padStart(2, "0");
                const dd = String(parsedDate.getUTCDate()).padStart(2, "0");
                return `${yyyy}-${mm}-${dd}`;
            }

            return trimmedValue;
        }

        if (value instanceof Date) {
            const yyyy = value.getFullYear();
            const mm = String(value.getMonth() + 1).padStart(2, "0");
            const dd = String(value.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        }

        return `${value}`.trim();
    };

    const formatDateForInput = (value) => {
        const normalized = formatDateForBackend(value);
        if (!normalized || normalized === "PENDIENTE") return "";
        return normalized;
    };

    const toggleMuestraPendiente = (index) => {
        setEstudios((prev) => {
            const next = [...prev];
            const item = next[index] || {};
            const pendienteActual = Boolean(
                item.muestraPendiente || `${item.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
            );
            next[index] = {
                ...item,
                muestraPendiente: !pendienteActual,
                fechaMuestra: !pendienteActual
                    ? "PENDIENTE"
                    : item.fechaMuestra === "PENDIENTE"
                        ? getFechaHoy()
                        : item.fechaMuestra || getFechaHoy(),
            };
            return next;
        });
    };

    const isValidDateString = (value) => {
        if (!value || typeof value !== "string") return false;

        const trimmedValue = value.trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) return false;

        const [year, month, day] = trimmedValue.split("-").map(Number);
        const date = new Date(Date.UTC(year, month - 1, day));

        return (
            date.getUTCFullYear() === year &&
            date.getUTCMonth() === month - 1 &&
            date.getUTCDate() === day
        );
    };

    const handleFechaMuestraBlur = (index, value) => {
        const trimmedValue = `${value || ""}`.trim();
        const nuevaFecha = formatDateForBackend(
            trimmedValue === ""
                ? getFechaHoy()
                : isValidDateString(trimmedValue)
                    ? trimmedValue
                    : getFechaHoy(),
        );

        setEstudios((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], fechaMuestra: nuevaFecha };
            return next;
        });
    };

    const getAbreviaturaSucursal = () => {
        const sucursalActual = (sucursales || []).find(
            (s) => String(s.idSucursal) === String(currentU?.sucursal),
        );

        const candidatos = [
            sucursalActual?.abreviatura,
            sucursalActual?.abr,
            sucursalActual?.siglas,
            sucursalActual?.codigo,
            currentU?.abreviaturaSucursal,
            currentU?.abreviatura,
            currentU?.nombreSucursal,
        ];

        const valor = candidatos.find((item) => {
            if (!item && item !== 0) return false;
            return `${item}`.trim() !== "";
        });

        if (!valor) return "SUC";

        const limpio = `${valor}`
            .normalize("NFD")
            .replace(/[^a-zA-Z0-9]/g, "")
            .toUpperCase();

        if (!limpio) return "SUC";

        return limpio.slice(0, 3);
    };

    const generarCodigoSolicitud = async () => {
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yy = String(now.getFullYear()).slice(-2);
        const fechaPrefix = `${dd}${mm}${yy}`;
        const abreviatura = getAbreviaturaSucursal();
        const prefix = `${fechaPrefix}${abreviatura}`;

        let dbSuccess = false;
        let maxSec = 0;
        try {
            const response = await SolicitudesService.getSolicitudes();
            const lista = response?.data?.solicitudes || [];
            if (response && response.data) {
                dbSuccess = true;
            }
            lista.forEach((sol) => {
                const codigo = sol.codigo || sol.orden || "";
                if (codigo.startsWith(prefix)) {
                    const suffixStr = codigo.substring(prefix.length);
                    const suffixNum = parseInt(suffixStr, 10);
                    if (!isNaN(suffixNum) && suffixNum > maxSec) {
                        maxSec = suffixNum;
                    }
                }
            });
        } catch (error) {
            console.error("Error al obtener solicitudes para generar código:", error);
        }

        const storageKey = "solicitudCodigoContador";
        const sucursalKey = `${yy}${mm}${dd}_${abreviatura}`;
        let contadorPorDia = {};

        try {
            contadorPorDia = JSON.parse(localStorage.getItem(storageKey) || "{}") || {};
        } catch (error) {
            contadorPorDia = {};
        }

        // Si la base de datos respondió correctamente, el consecutivo real es maxSec + 1
        // Solo se utiliza el contador local como respaldo en caso de fallo de red
        let siguiente;
        if (dbSuccess) {
            siguiente = maxSec + 1;
        } else {
            const localSiguiente = Number(contadorPorDia[sucursalKey] || 0) + 1;
            siguiente = Math.max(maxSec + 1, localSiguiente);
        }

        contadorPorDia[sucursalKey] = siguiente;

        try {
            localStorage.setItem(storageKey, JSON.stringify(contadorPorDia));
        } catch (e) {
            console.error(e);
        }

        return `${prefix}${siguiente}`;
    };

    const agregarSolicitud = async () => {
        const cleaned = removeAllEmpty(estudios).map((est) => {
            const payloadEstudio = {
                ...est,
                fechaMuestra: formatDateForBackend(est.fechaMuestra),
                fechaEntrega: formatDateForBackend(est.fechaEntrega),
            };

            if (est.urgente !== undefined) {
                payloadEstudio.urgente = est.urgente;
            } else {
                const originalEstudio = estudiosOriginales.find((orig) =>
                    String(orig.idEstudio ?? "") === String(est.idEstudio ?? ""),
                );
                payloadEstudio.urgente = originalEstudio?.urgente !== undefined
                    ? originalEstudio.urgente
                    : false;
            }

            return payloadEstudio;
        });

        if (!tieneUnoConDatos(cleaned)) {
            mostrarError("Es necesario seleccionar al menos un estudio.");
            return;
        }

        if (errorDescuentoGeneral || erroresDescuentoEstudios.some(Boolean)) {
            mostrarError(
                errorDescuentoGeneral ||
                erroresDescuentoEstudios.find(Boolean) ||
                "Por favor corrige los errores de descuento antes de guardar.",
            );
            return;
        }

        if (pacientesExcel.length === 0) {
            mostrarError("Es necesario seleccionar y cargar el archivo Excel con los pacientes.");
            return;
        }

        const faltanFechaEntrega = cleaned.some((est) => !isEstudioEmpty(est) && (!est.fechaEntrega || est.fechaEntrega === ""));
        if (faltanFechaEntrega) {
            Swal.fire({
                title: "Faltan fechas de entrega",
                text: "Todos los estudios deben tener fecha de entrega antes de continuar.",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
            return;
        }

        // Comprobación para evitar doctores duplicados
        const docKeys = [];
        if (selectedDoctor?.idDoctor) {
            docKeys.push(`id:${selectedDoctor.idDoctor}`);
        } else if (nombreDoctor) {
            const nameKey = `${nombreDoctor} ${apPaternoDoctor || ""} ${apMaternoDoctor || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
            if (nameKey) docKeys.push(`name:${nameKey}`);
        }

        if (cantidadDoctores >= 2) {
            if (selectedDoctor2?.idDoctor) {
                docKeys.push(`id:${selectedDoctor2.idDoctor}`);
            } else if (nombreDoctor2) {
                const nameKey2 = `${nombreDoctor2} ${apPaternoDoctor2 || ""} ${apMaternoDoctor2 || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
                if (nameKey2) docKeys.push(`name:${nameKey2}`);
            }
        }

        if (cantidadDoctores === 3) {
            if (selectedDoctor3?.idDoctor) {
                docKeys.push(`id:${selectedDoctor3.idDoctor}`);
            } else if (nombreDoctor3) {
                const nameKey3 = `${nombreDoctor3} ${apPaternoDoctor3 || ""} ${apMaternoDoctor3 || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
                if (nameKey3) docKeys.push(`name:${nameKey3}`);
            }
        }

        if (new Set(docKeys).size !== docKeys.length) {
            mostrarError("No se puede seleccionar ni agregar el mismo doctor más de una vez.");
            return;
        }

        let enviarEmailC = enviarEmail === "seleccione" ? "no" : enviarEmail;
        let enviarEmailDC = enviarEmailD === "seleccione" ? "no" : enviarEmailD;
        let enviarWhatsappC = enviarWhatsapp === "seleccione" ? "no" : enviarWhatsapp;
        let enviarWhatsappDC = enviarWhatsappD === "seleccione" ? "no" : enviarWhatsappD;

        try {
            Swal.fire({
                title: "Procesando carga masiva",
                html: `Iniciando registro de solicitudes para ${pacientesExcel.length} pacientes...`,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            let creadasCount = 0;

            for (let i = 0; i < pacientesExcel.length; i++) {
                const p = pacientesExcel[i];

                Swal.update({
                    html: `Registrando paciente ${i + 1} de ${pacientesExcel.length}: <b>${p.nombre} ${p.apPaterno}</b>`
                });

                // Generar código de solicitud
                const codigoSolicitud = await generarCodigoSolicitud();

                // Buscar duplicados
                const pacienteExistente = encontrarPacienteExistente(p);

                let solicitudPayload = {
                    solicitud: {
                        enviarEmail: enviarEmailC,
                        enviarWhatsapp: enviarWhatsappC,
                        enviarEmailD: enviarEmailDC,
                        enviarWhatsappD: enviarWhatsappDC,
                        numCuarto: p.numCuarto || numCuarto || "",
                        notas: notas,
                        descuentoTotal: valorGeneral,
                        motivoDescuento: motivoDescuento,
                        tipoDescuento: opcionDescuento,
                        totalPagar: totalResumen,
                        requiereFactura: requiereFactura ? 1 : 0,
                        idSucursal: currentU.sucursal,
                        fecha: getFormattedNow(),
                        estatus: "S",
                        motivoCancelacion: "",
                        inserto: currentU.id,
                        codigo: codigoSolicitud
                    },
                    estudios: cleaned
                };

                if (pacienteExistente) {
                    solicitudPayload.solicitud.idPaciente = pacienteExistente.idPaciente;
                } else {
                    solicitudPayload.paciente = {
                        nombre: p.nombre,
                        apPaterno: p.apPaterno,
                        apMaterno: p.apMaterno,
                        fechaNacimiento: p.fechaNacimiento || null,
                        edad: p.edad || null,
                        sexo: p.sexo || null,
                        email: p.email || "",
                        telefonoCelular: p.telefonoCelular || "",
                        direccion: p.direccion || "",
                        colonia: p.colonia || "",
                        cPostal: p.cPostal || "",
                        estado: p.estado === "" || p.estado === "seleccione" ? null : p.estado,
                        ciudad: p.ciudad || "",
                        ine: p.ine || ""
                    };
                }

                if (selectedEmpresa) {
                    solicitudPayload.solicitud.idConvenio = selectedEmpresa.idConvenio;
                } else {
                    solicitudPayload.solicitud.idConvenio = null;
                }

                // Doctors
                const idDoctoresArr = [];

                if (selectedDoctor?.idDoctor) {
                    solicitudPayload.solicitud.idDoctor = selectedDoctor.idDoctor;
                    idDoctoresArr.push(selectedDoctor.idDoctor);
                } else if (nombreDoctor && nombreDoctor.trim() !== "") {
                    solicitudPayload.solicitud.idDoctor = null;
                    const dObj = {
                        nombre: nombreDoctor,
                        apPaterno: apPaternoDoctor || "",
                        apMaterno: apMaternoDoctor || "",
                        telefonoCelular: telefonoDoctor || "",
                        email: emailDoctor || "",
                        esComision: esComisionD ? 1 : 0,
                    };
                    solicitudPayload.doctor = dObj;
                    solicitudPayload.solicitud.doctor = dObj;
                } else {
                    solicitudPayload.solicitud.idDoctor = 1;
                    idDoctoresArr.push(1);
                }

                if (cantidadDoctores >= 2) {
                    if (selectedDoctor2?.idDoctor) {
                        solicitudPayload.solicitud.idDoctor2 = selectedDoctor2.idDoctor;
                        idDoctoresArr.push(selectedDoctor2.idDoctor);
                    } else if (nombreDoctor2) {
                        solicitudPayload.solicitud.idDoctor2 = null;
                        const dObj2 = {
                            nombre: nombreDoctor2,
                            apPaterno: apPaternoDoctor2 || "",
                            apMaterno: apMaternoDoctor2 || "",
                            telefonoCelular: telefonoDoctor2 || "",
                            email: emailDoctor2 || "",
                            esComision: esComisionD2 ? 1 : 0,
                        };
                        solicitudPayload.doctor2 = dObj2;
                        solicitudPayload.solicitud.doctor2 = dObj2;
                    } else {
                        solicitudPayload.solicitud.idDoctor2 = null;
                    }
                } else {
                    solicitudPayload.solicitud.idDoctor2 = null;
                }

                if (cantidadDoctores === 3) {
                    if (selectedDoctor3?.idDoctor) {
                        solicitudPayload.solicitud.idDoctor3 = selectedDoctor3.idDoctor;
                        idDoctoresArr.push(selectedDoctor3.idDoctor);
                    } else if (nombreDoctor3) {
                        solicitudPayload.solicitud.idDoctor3 = null;
                        const dObj3 = {
                            nombre: nombreDoctor3,
                            apPaterno: apPaternoDoctor3 || "",
                            apMaterno: apMaternoDoctor3 || "",
                            telefonoCelular: telefonoDoctor3 || "",
                            email: emailDoctor3 || "",
                            esComision: esComisionD3 ? 1 : 0,
                        };
                        solicitudPayload.doctor3 = dObj3;
                        solicitudPayload.solicitud.doctor3 = dObj3;
                    } else {
                        solicitudPayload.solicitud.idDoctor3 = null;
                    }
                } else {
                    solicitudPayload.solicitud.idDoctor3 = null;
                }

                solicitudPayload.solicitud.idDoctores = idDoctoresArr;

                const resultado = await SolicitudesService.agregarSolicitud(solicitudPayload);
                if (resultado.data.estatus === "OK") {
                    creadasCount++;
                    const nuevoId = resultado.data.idSolicitud || resultado.data.id;
                    if (nuevoId) {
                        registrarMovimientoSolicitud("CRE", `Creación de la solicitud ${codigoSolicitud || ""}`, nuevoId);
                    }
                    if (codigoSolicitud && cotizacionHeader?.idCotizacion) {
                        try {
                            let cotizacion = {
                                conversionSol: codigoSolicitud,
                            };
                            await CotizacionesService.updateCodigoCotizacion(
                                cotizacion,
                                cotizacionHeader.idCotizacion,
                            );
                        } catch (error) {
                            console.error("Error al vincular cotización:", error);
                        }
                    }
                } else {
                    throw new Error(resultado.data.mensaje || `No se pudo registrar la solicitud del paciente ${p.nombre}`);
                }
            }

            Swal.fire({
                title: "Carga Masiva Exitosa",
                text: `Se registraron exitosamente ${creadasCount} solicitudes.`,
                icon: "success",
                confirmButtonText: "Aceptar"
            }).then(() => {
                reloadPage();
            });

        } catch (error) {
            console.error("Error en la carga masiva:", error);
            mostrarError("Ocurrió un error al procesar el lote: " + error.message);
        }
    };


    return (
        <Layout>
            <Content>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "50%",
                        paddingTop: "2vh",
                        paddingBottom: "2vh",
                    }}
                >
                    <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
                        <Snackbar
                            open={snackbar.open}
                            autoHideDuration={3000}
                            onClose={() =>
                                setSnackbar((prev) => ({ ...prev, open: false }))
                            }
                            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        >
                            <Alert
                                onClose={() =>
                                    setSnackbar((prev) => ({ ...prev, open: false }))
                                }
                                severity={snackbar.severity}
                                sx={{ width: "100%" }}
                            >
                                {snackbar.message}
                            </Alert>
                        </Snackbar>
                        <Paper
                            elevation={3}
                            sx={{ p: 2, borderRadius: 4 }}
                            className="paperCot"
                        >
                            <Grid item xs={12}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Instrucciones
                                </Typography>
                                <Typography variant="body2">
                                    <Box
                                        component="span"
                                        sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                                    >
                                        •
                                    </Box>{" "}
                                    Antes de realizar la carga del archivo de Excel con los pacientes, verifiqur la estructura que conlleva el mismo, ya que cada celda tiene un valor asignado que se colocara dentro de la solicitud.
                                </Typography>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Notas:
                                </Typography>
                                <Typography variant="body2">
                                    <Box
                                        component="span"
                                        sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                                    >
                                        •
                                    </Box>{" "}
                                    Al editar el archivo de Excel para eliminar algun paciente, elimine la fila completa, no solo la infomacion, para evitar errores.
                                </Typography>
                                <Typography variant="body2">
                                    <Box
                                        component="span"
                                        sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                                    >
                                        •
                                    </Box>{" "}
                                    La fecha de nacimiento debe tener el formato: dd/mm/aaaa o dd-mm-aaaa, en caso de ser diferente no se podra guardar correctamente ni calcular la edad automaticamente de ser necesario.
                                </Typography>
                                <Typography variant="body2">
                                    <Box
                                        component="span"
                                        sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                                    >
                                        •
                                    </Box>{" "}
                                    La edad debe de llevar el numero de años y la palabra AÑOS, DIAS o MESES, ya que si solo se pone el numero se tomara como si fueran años por defecto.
                                </Typography>
                                <Typography variant="body2">
                                    <Box
                                        component="span"
                                        sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                                    >
                                        •
                                    </Box>{" "}
                                    Si no tiene el archivo, lo puede descargar{" "}
                                    <a
                                        href={templateFile}
                                        download="archivoPacientes.xlsx"
                                        style={{ color: "#006787", fontWeight: "bold", textDecoration: "underline" }}
                                    >
                                        AQUÍ
                                    </a>.
                                </Typography>
                            </Grid>
                        </Paper>
                        <Paper
                            elevation={3}
                            sx={{ p: 2, borderRadius: 4 }}
                            className="paperSol"
                        >
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography
                                        variant="h7"
                                        fontWeight="bold"
                                        gutterBottom
                                        sx={{
                                            fontWeight: "bold",
                                            background: "linear-gradient(90deg, #006787, #014e65)",
                                            color: "white",
                                            padding: "0.5vw 0.5vw",
                                            borderRadius: "8px",
                                            display: "inline-block",
                                        }}
                                    >
                                        Archivo de pacientes:
                                    </Typography>
                                </Box>
                            </Grid>


                            {/* Contenedor principal */}
                            <Grid container spacing={"0.3vw"}>
                                <Grid
                                    item
                                    xs={12}
                                    container
                                    spacing={"1vw"}
                                    sx={{ paddingTop: "0.6vw" }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        spacing={"1vw"}
                                        sx={{ paddingTop: "0.4vw" }}
                                    >
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={6}>
                                                <InputLabel
                                                    htmlFor="archivoPacientes"
                                                    sx={{
                                                        color: "black",
                                                        fontSize: "1vw",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Seleccione el archivo con los pacientes <span style={{ color: "red" }}>*</span>
                                                </InputLabel>
                                                <TextField
                                                    id="archivoPacientes"
                                                    type="file"
                                                    inputProps={{ accept: ".xlsx, .xls" }}
                                                    onChange={handleFileChange}
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            height: "5vh",
                                                            width: "28vw",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            fontSize: "1vw",
                                                            padding: "0.5vw",
                                                        },
                                                    }}
                                                />
                                                {nombreArchivo && (
                                                    <Typography variant="caption" display="block" sx={{ mt: 1, color: "green", fontWeight: "bold" }}>
                                                        Archivo seleccionado: {nombreArchivo} ({pacientesExcel.length} pacientes cargados)
                                                    </Typography>
                                                )}
                                            </Grid>
                                        </Stack>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        spacing={"1vw"}
                                        sx={{ paddingTop: "0.4vw" }}
                                    >
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={6}>
                                                <InputLabel
                                                    htmlFor="txfPacienteReferido"
                                                    sx={{
                                                        color: "black",
                                                        fontSize: "1vw",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    ¿El paciente es referido de alguna
                                                    Empresa/Institucion?
                                                </InputLabel>
                                                <Autocomplete
                                                    disabled={viewOnly || viewOnlyE || editModeG}
                                                    options={empresas}
                                                    value={empresa}
                                                    popupIcon={null}
                                                    getOptionLabel={(option) => (option ? option.nombre : "")}
                                                    onChange={async (event, value) => {
                                                        await actualizarListaPreciosParaConvenio(value);
                                                    }}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option.idConvenio === (value ? value.idConvenio : null)
                                                    }
                                                    inputValue={empresa}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            disabled={viewOnlyE || editModeG || viewOnly}
                                                            value={empresa}
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: "5vh",
                                                                    width: "28vw",
                                                                },
                                                                "& .MuiInputBase-input": {
                                                                    fontSize: "1vw",
                                                                    padding: "0.5vw",
                                                                },
                                                            }}
                                                            className="txfNombreEmpresa"
                                                        />
                                                    )}
                                                    filterOptions={(options, state) => {
                                                        const input = (state.inputValue || "")
                                                            .trim()
                                                            .toLowerCase();
                                                        if (!input) return options;
                                                        return options.filter((opt) => {
                                                            const combined = `${opt.nombre || ""}`.toLowerCase();
                                                            return combined.includes(input);
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                {!viewOnly && !editModeG ? (
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            marginTop: "0.5vw",
                                                        }}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            onClick={changeEmpresa}
                                                            sx={{
                                                                fontSize: "0.7vw",
                                                                backgroundColor: "#9f7003",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                borderRadius: "8px",
                                                                padding: "0.5vw 1vw",
                                                                "&:hover": {
                                                                    backgroundColor: "#7e9405",
                                                                    transform: "scale(1.05)",
                                                                },
                                                            }}
                                                            startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                                                        >
                                                            Cambiar empresa
                                                        </Button>
                                                    </Box>
                                                ) : null}
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper
                            elevation={3}
                            sx={{ p: 2, borderRadius: 4 }}
                            className="paperLugar"
                        >
                            {/* Lugar de atencion */}
                            <Grid
                                item
                                xs={12}
                                container
                                spacing={"1vw"}
                                sx={{ paddingTop: "0vw" }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography
                                        variant="h7"
                                        fontWeight="bold"
                                        gutterBottom
                                        align="center"
                                        sx={{
                                            fontWeight: "bold",
                                            background: "linear-gradient(90deg, #006787, #014e65)",
                                            color: "white",
                                            padding: "0.5vw 1vw",
                                            borderRadius: "8px",
                                            display: "inline-block",
                                            marginTop: "0vw",
                                        }}
                                    >
                                        Ficha de datos del doctor:
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                {!esEstatusSoloLectura(solicitudEstatus) && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: "0.5vw",
                                        }}
                                    >
                                        <Button
                                            onClick={changeDoctor}
                                            variant="contained"
                                            sx={{
                                                fontSize: "0.7vw",
                                                backgroundColor: "#9f7003",
                                                color: "white",
                                                borderRadius: "8px",
                                                fontWeight: "bold",
                                                padding: "0.5vw 1vw",
                                                "&:hover": {
                                                    backgroundColor: "#7e9405",
                                                    transform: "scale(1.05)",
                                                },
                                            }}
                                            startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                                        >
                                            Cambiar doctor
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={changeEditModeM}
                                            sx={{
                                                marginLeft: "0.5vw",
                                                fontSize: "0.7vw",
                                                backgroundColor: "#9f7003",
                                                color: "white",
                                                borderRadius: "8px",
                                                fontWeight: "bold",
                                                padding: "0.5vw 1vw",
                                                "&:hover": {
                                                    backgroundColor: "#7e9405",
                                                    transform: "scale(1.05)",
                                                },
                                            }}
                                            startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                                        >
                                            Editar doctor
                                        </Button>
                                    </Box>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                container
                                spacing={"2vw"}
                                sx={{ paddingTop: "0.4vw" }}
                            >
                                <Stack direction="row" spacing={"3vw"}>
                                    <Grid item xs={6}>
                                        <InputLabel
                                            htmlFor="txfNombreDoctor"
                                            sx={{
                                                color: "black",
                                                fontSize: "1vw",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Nombre:
                                        </InputLabel>
                                        {editModeM ? (
                                            <TextField
                                                value={nombreDoctor}
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                onChange={(e) => setNombreDoctor(e.target.value)}
                                                onBlur={() => saveFieldM("nombre", nombreDoctor)}
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        width: "13vw",
                                                        height: "5vh",
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        fontSize: "1vw",
                                                        padding: "0.5vw",
                                                    },
                                                }}
                                                className="txfNombreDoctor"
                                                InputProps={{
                                                    endAdornment: saving.nombreDoctor ? (
                                                        <CircularProgress size={16} />
                                                    ) : null,
                                                }}
                                            />
                                        ) : (
                                            <Autocomplete
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                options={doctores}
                                                value={selectedDoctor}
                                                popupIcon={null}
                                                getOptionLabel={(option) =>
                                                    option
                                                        ? option.nombre +
                                                        " " +
                                                        option.apPaterno +
                                                        " " +
                                                        option.apMaterno
                                                        : ""
                                                }
                                                onChange={(event, value) => {
                                                    setSelectedDoctor(value);
                                                    if (value) {
                                                        setNombreDoctor(value.nombre || "");
                                                        setApPaternoDoctor(value.apPaterno || "");
                                                        setApMaternoDoctor(value.apMaterno || "");
                                                    }
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.idDoctor ===
                                                    (value ? value.idDoctor : null)
                                                }
                                                inputValue={nombreDoctor} // controla lo que se ve en el input
                                                onInputChange={(event, newInputValue, reason) => {
                                                    // si el usuario escribe, desvinculamos la selección para que no reemplace el texto
                                                    if (reason === "input") {
                                                        setSelectedDoctor(null);
                                                        setNombreDoctor(newInputValue);
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                        value={nombreDoctor}
                                                        onChange={(e) => setNombreDoctor(e.target.value)}
                                                        error={errorNombreDoctor}
                                                        helperText={
                                                            errorNombreDoctor ? "Nombre obligatorio" : ""
                                                        }
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                width: "13vw",
                                                                height: "5vh",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                fontSize: "1vw",
                                                                padding: "0.5vw",
                                                            },
                                                        }}
                                                        className="txfNombreDoctor"
                                                    />
                                                )}
                                                filterOptions={(options, state) => {
                                                    const input = (state.inputValue || "")
                                                        .trim()
                                                        .toLowerCase();
                                                    if (!input) return options;
                                                    return options.filter((opt) => {
                                                        const combined =
                                                            `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                                                        return combined.includes(input);
                                                    });
                                                }}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputLabel
                                            htmlFor="txfApPaternoDoctor"
                                            sx={{
                                                color: "black",
                                                fontSize: "1vw",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Apellido Paterno:
                                        </InputLabel>
                                        {editModeM ? (
                                            <TextField
                                                value={apPaternoDoctor}
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                onChange={(e) => setApPaternoDoctor(e.target.value)}
                                                onBlur={() => saveFieldM("apPaterno", apPaternoDoctor)}
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        width: "13vw",
                                                        height: "5vh",
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        fontSize: "1vw",
                                                        padding: "0.5vw",
                                                    },
                                                }}
                                                className="txfApPaterno"
                                                InputProps={{
                                                    endAdornment: saving.apPaternoDoctor ? (
                                                        <CircularProgress size={16} />
                                                    ) : null,
                                                }}
                                            />
                                        ) : (
                                            <Autocomplete
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                options={doctores}
                                                value={selectedDoctor}
                                                popupIcon={null}
                                                getOptionLabel={(option) =>
                                                    option
                                                        ? option.nombre +
                                                        " " +
                                                        option.apPaterno +
                                                        " " +
                                                        option.apMaterno
                                                        : ""
                                                }
                                                onChange={(event, value) => {
                                                    setSelectedDoctor(value);
                                                    setViewOnly(true);
                                                    if (value) {
                                                        setNombreDoctor(value.nombre || "");
                                                        setApPaternoDoctor(value.apPaterno || "");
                                                        setApMaternoDoctor(value.apMaterno || "");
                                                    }
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.idDoctor ===
                                                    (value ? value.idDoctor : null)
                                                }
                                                inputValue={apPaternoDoctor}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === "input") {
                                                        setSelectedDoctor(null);
                                                        setApPaternoDoctor(newInputValue);
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        value={apPaternoDoctor}
                                                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                        error={errorApPaternoDoctor}
                                                        helperText={
                                                            errorApPaternoDoctor
                                                                ? "Apellido paterno obligatorio"
                                                                : ""
                                                        }
                                                        onChange={(e) => setApPaternoDoctor(e.target.value)}
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                height: "5vh",
                                                                width: "13vw",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                fontSize: "1vw",
                                                                padding: "0.5vw",
                                                            },
                                                        }}
                                                        className="txfApPaternoDoctor"
                                                    />
                                                )}
                                                filterOptions={(options, state) => {
                                                    const input = (state.inputValue || "")
                                                        .trim()
                                                        .toLowerCase();
                                                    if (!input) return options;
                                                    return options.filter((opt) => {
                                                        const combined =
                                                            `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                                                        return combined.includes(input);
                                                    });
                                                }}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputLabel
                                            htmlFor="txfApMaternoDoctor"
                                            sx={{
                                                color: "black",
                                                fontSize: "1vw",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Apellido Materno:
                                        </InputLabel>
                                        {editModeM ? (
                                            <TextField
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                value={apMaternoDoctor}
                                                onChange={(e) => setApMaternoDoctor(e.target.value)}
                                                onBlur={() => saveFieldM("apMaterno", apMaternoDoctor)}
                                                InputProps={{
                                                    endAdornment: saving.apMaternoDoctor ? (
                                                        <CircularProgress size={16} />
                                                    ) : null,
                                                }}
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        width: "13vw",
                                                        height: "5vh",
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        fontSize: "1vw",
                                                        padding: "0.5vw",
                                                    },
                                                }}
                                                className="txfApMaternoDoctor"
                                            />
                                        ) : (
                                            <Autocomplete
                                                disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                options={doctores}
                                                value={selectedDoctor}
                                                popupIcon={null}
                                                getOptionLabel={(option) =>
                                                    option
                                                        ? option.nombre +
                                                        " " +
                                                        option.apPaterno +
                                                        " " +
                                                        option.apMaterno
                                                        : ""
                                                }
                                                onChange={(event, value) => {
                                                    setSelectedDoctor(value);
                                                    setViewOnly(true);
                                                    if (value) {
                                                        setNombreDoctor(value.nombre || "");
                                                        setApPaternoDoctor(value.apPaterno || "");
                                                        setApMaternoDoctor(value.apMaterno || "");
                                                    }
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.idDoctor ===
                                                    (value ? value.idDoctor : null)
                                                }
                                                inputValue={apMaternoDoctor}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === "input") {
                                                        setSelectedDoctor(null);
                                                        setApMaternoDoctor(newInputValue);
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                        value={apMaternoDoctor}
                                                        onChange={(e) => setApMaternoDoctor(e.target.value)}
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                height: "5vh",
                                                                width: "13vw",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                fontSize: "1vw",
                                                                padding: "0.5vw",
                                                            },
                                                        }}
                                                        className="txfApMaternoDoctor"
                                                    />
                                                )}
                                                filterOptions={(options, state) => {
                                                    const input = (state.inputValue || "")
                                                        .trim()
                                                        .toLowerCase();
                                                    if (!input) return options;
                                                    return options.filter((opt) => {
                                                        const combined =
                                                            `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                                                        return combined.includes(input);
                                                    });
                                                }}
                                            />
                                        )}
                                    </Grid>
                                </Stack>
                            </Grid>

                            <Grid item xs={12} container spacing={"1vw"} sx={{ paddingTop: "0.5vw" }}>
                                <Stack direction="row" spacing={"3vw"}>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={esComisionD}
                                                    onChange={(e) => {
                                                        const val = e.target.checked;
                                                        setEsComisionD(val);
                                                        if (selectedDoctor) {
                                                            setSelectedDoctor((prev) => ({ ...prev, esComision: val, conComision: val }));
                                                        }
                                                        if (editModeM && selectedDoctor?.idDoctor) {
                                                            saveFieldM("conComision", val ? 1 : 0, 1);
                                                        }
                                                    }}
                                                    disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            height: "1.2vw",
                                                            width: "1.2vw",
                                                        },
                                                    }}
                                                />
                                            }
                                            label={
                                                <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "black" }}>
                                                    Doctor con comisión
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                </Stack>
                            </Grid>

                            {/* Doctor 2 Form */}
                            {cantidadDoctores >= 2 && (
                                <>
                                    <Box sx={{ mt: 3, mb: 1, borderTop: "1px solid #ccc", pt: 2, display: "flex", justifyContent: "flex-end" }}>
                                        {!esEstatusSoloLectura(solicitudEstatus) && (
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5vw" }}>
                                                <Box sx={{ display: "flex", gap: "0.5vw" }}>
                                                    <Button
                                                        onClick={changeDoctor2}
                                                        variant="contained"
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            backgroundColor: "#9f7003",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            fontWeight: "bold",
                                                            padding: "0.5vw 1vw",
                                                            "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                                                        }}
                                                        startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                                                    >
                                                        Cambiar doctor
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        onClick={changeEditModeM2}
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            backgroundColor: "#9f7003",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            fontWeight: "bold",
                                                            padding: "0.5vw 1vw",
                                                            "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                                                        }}
                                                        startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                                                    >
                                                        Editar doctor
                                                    </Button>
                                                </Box>
                                                {!viewOnly && (
                                                    <Button
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => {
                                                            if (cantidadDoctores === 3) {
                                                                setSelectedDoctor2(selectedDoctor3);
                                                                setNombreDoctor2(nombreDoctor3);
                                                                setApPaternoDoctor2(apPaternoDoctor3);
                                                                setApMaternoDoctor2(apMaternoDoctor3);
                                                                setEmailDoctor2(emailDoctor3);
                                                                setTelefonoDoctor2(telefonoDoctor3);
                                                                setEnviarEmailD2(enviarEmailD3);
                                                                setEnviarWhatsappD2(enviarWhatsappD3);
                                                                setEsComisionD2(esComisionD3);
                                                                setEditModeM2(editModeM3);
                                                                setViewOnlyM2(viewOnlyM3);

                                                                setSelectedDoctor3(null);
                                                                setNombreDoctor3("");
                                                                setApPaternoDoctor3("");
                                                                setApMaternoDoctor3("");
                                                                setEmailDoctor3("");
                                                                setTelefonoDoctor3("");
                                                                setEnviarEmailD3("no");
                                                                setEnviarWhatsappD3("no");
                                                                setEsComisionD3(false);
                                                                setEditModeM3(false);
                                                                setViewOnlyM3(false);
                                                                setCantidadDoctores((prev) => prev - 1);
                                                            } else {
                                                                setSelectedDoctor2(null);
                                                                setNombreDoctor2("");
                                                                setApPaternoDoctor2("");
                                                                setApMaternoDoctor2("");
                                                                setEmailDoctor2("");
                                                                setTelefonoDoctor2("");
                                                                setEnviarEmailD2("no");
                                                                setEnviarWhatsappD2("no");
                                                                setEsComisionD2(false);
                                                                setEditModeM2(false);
                                                                setViewOnlyM2(false);
                                                            }
                                                            setCantidadDoctores((prev) => prev - 1);
                                                        }}
                                                        startIcon={<DeleteIcon />}
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            fontWeight: "bold",
                                                            borderRadius: "8px",
                                                            padding: "0.5vw 1vw",
                                                        }}
                                                    >
                                                        Quitar doctor
                                                    </Button>
                                                )}
                                            </Box>
                                        )}
                                    </Box>

                                    <Grid item xs={12} container spacing={"2vw"} sx={{ paddingTop: "0.4vw" }}>
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Nombre:</InputLabel>
                                                {editModeM2 ? (
                                                    <TextField
                                                        value={nombreDoctor2}
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        onChange={(e) => setNombreDoctor2(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor2}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor2(value);
                                                            if (value) {
                                                                setNombreDoctor2(value.nombre || "");
                                                                setApPaternoDoctor2(value.apPaterno || "");
                                                                setApMaternoDoctor2(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={nombreDoctor2}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor2(null);
                                                                setNombreDoctor2(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                                error={errorNombreDoctor2}
                                                                helperText={errorNombreDoctor2 ? "Nombre obligatorio" : ""}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Paterno:</InputLabel>
                                                {editModeM2 ? (
                                                    <TextField
                                                        value={apPaternoDoctor2}
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        onChange={(e) => setApPaternoDoctor2(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor2}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor2(value);
                                                            if (value) {
                                                                setNombreDoctor2(value.nombre || "");
                                                                setApPaternoDoctor2(value.apPaterno || "");
                                                                setApMaternoDoctor2(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={apPaternoDoctor2}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor2(null);
                                                                setApPaternoDoctor2(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                                error={errorApPaternoDoctor2}
                                                                helperText={errorApPaternoDoctor2 ? "Apellido obligatorio" : ""}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Materno:</InputLabel>
                                                {editModeM2 ? (
                                                    <TextField
                                                        value={apMaternoDoctor2}
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        onChange={(e) => setApMaternoDoctor2(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor2}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor2(value);
                                                            if (value) {
                                                                setNombreDoctor2(value.nombre || "");
                                                                setApPaternoDoctor2(value.apPaterno || "");
                                                                setApMaternoDoctor2(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={apMaternoDoctor2}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor2(null);
                                                                setApMaternoDoctor2(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} container spacing={"1vw"} sx={{ paddingTop: "0.5vw" }}>
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={esComisionD2}
                                                            onChange={(e) => {
                                                                const val = e.target.checked;
                                                                setEsComisionD2(val);
                                                                if (selectedDoctor2) {
                                                                    setSelectedDoctor2((prev) => ({ ...prev, esComision: val, conComision: val }));
                                                                }
                                                                if (editModeM2 && selectedDoctor2?.idDoctor) {
                                                                    saveFieldM("conComision", val ? 1 : 0, 2);
                                                                }
                                                            }}
                                                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    height: "1.2vw",
                                                                    width: "1.2vw",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "black" }}>
                                                            Doctor con comisión
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                </>
                            )}

                            {/* Doctor 3 Form */}
                            {cantidadDoctores === 3 && (
                                <>
                                    <Box sx={{ mt: 3, mb: 1, borderTop: "1px solid #ccc", pt: 2, display: "flex", justifyContent: "flex-end" }}>
                                        {!esEstatusSoloLectura(solicitudEstatus) && (
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5vw" }}>
                                                <Box sx={{ display: "flex", gap: "0.5vw" }}>
                                                    <Button
                                                        onClick={changeDoctor3}
                                                        variant="contained"
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            backgroundColor: "#9f7003",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            fontWeight: "bold",
                                                            padding: "0.5vw 1vw",
                                                            "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                                                        }}
                                                        startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                                                    >
                                                        Cambiar doctor
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        onClick={changeEditModeM3}
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            backgroundColor: "#9f7003",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            fontWeight: "bold",
                                                            padding: "0.5vw 1vw",
                                                            "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                                                        }}
                                                        startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                                                    >
                                                        Editar doctor
                                                    </Button>
                                                </Box>
                                                {!viewOnly && (
                                                    <Button
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => {
                                                            setSelectedDoctor3(null);
                                                            setNombreDoctor3("");
                                                            setApPaternoDoctor3("");
                                                            setApMaternoDoctor3("");
                                                            setEmailDoctor3("");
                                                            setTelefonoDoctor3("");
                                                            setEnviarEmailD3("no");
                                                            setEnviarWhatsappD3("no");
                                                            setCantidadDoctores((prev) => prev - 1);
                                                        }}
                                                        startIcon={<DeleteIcon />}
                                                        sx={{
                                                            fontSize: "0.7vw",
                                                            fontWeight: "bold",
                                                            borderRadius: "8px",
                                                            padding: "0.5vw 1vw",
                                                        }}
                                                    >
                                                        Quitar doctor
                                                    </Button>
                                                )}
                                            </Box>
                                        )}
                                    </Box>

                                    <Grid item xs={12} container spacing={"2vw"} sx={{ paddingTop: "0.4vw" }}>
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Nombre:</InputLabel>
                                                {editModeM3 ? (
                                                    <TextField
                                                        value={nombreDoctor3}
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        onChange={(e) => setNombreDoctor3(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor3}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor3(value);
                                                            if (value) {
                                                                setNombreDoctor3(value.nombre || "");
                                                                setApPaternoDoctor3(value.apPaterno || "");
                                                                setApMaternoDoctor3(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={nombreDoctor3}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor3(null);
                                                                setNombreDoctor3(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                                error={errorNombreDoctor3}
                                                                helperText={errorNombreDoctor3 ? "Nombre obligatorio" : ""}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Paterno:</InputLabel>
                                                {editModeM3 ? (
                                                    <TextField
                                                        value={apPaternoDoctor3}
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        onChange={(e) => setApPaternoDoctor3(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor3}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor3(value);
                                                            if (value) {
                                                                setNombreDoctor3(value.nombre || "");
                                                                setApPaternoDoctor3(value.apPaterno || "");
                                                                setApMaternoDoctor3(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={apPaternoDoctor3}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor3(null);
                                                                setApPaternoDoctor3(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                                error={errorApPaternoDoctor3}
                                                                helperText={errorApPaternoDoctor3 ? "Apellido obligatorio" : ""}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Materno:</InputLabel>
                                                {editModeM3 ? (
                                                    <TextField
                                                        value={apMaternoDoctor3}
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        onChange={(e) => setApMaternoDoctor3(e.target.value)}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                            "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                        options={doctores}
                                                        value={selectedDoctor3}
                                                        popupIcon={null}
                                                        getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                                                        onChange={(event, value) => {
                                                            setSelectedDoctor3(value);
                                                            if (value) {
                                                                setNombreDoctor3(value.nombre || "");
                                                                setApPaternoDoctor3(value.apPaterno || "");
                                                                setApMaternoDoctor3(value.apMaterno || "");
                                                            }
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                                                        inputValue={apMaternoDoctor3}
                                                        onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === "input") {
                                                                setSelectedDoctor3(null);
                                                                setApMaternoDoctor3(newInputValue);
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                                                }}
                                                            />
                                                        )}
                                                        filterOptions={(options, state) => {
                                                            const input = (state.inputValue || "").trim().toLowerCase();
                                                            if (!input) return options;
                                                            return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} container spacing={"1vw"} sx={{ paddingTop: "0.5vw" }}>
                                        <Stack direction="row" spacing={"3vw"}>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={esComisionD3}
                                                            onChange={(e) => {
                                                                const val = e.target.checked;
                                                                setEsComisionD3(val);
                                                                if (selectedDoctor3) {
                                                                    setSelectedDoctor3((prev) => ({ ...prev, esComision: val, conComision: val }));
                                                                }
                                                                if (editModeM3 && selectedDoctor3?.idDoctor) {
                                                                    saveFieldM("conComision", val ? 1 : 0, 3);
                                                                }
                                                            }}
                                                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    height: "1.2vw",
                                                                    width: "1.2vw",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "black" }}>
                                                            Doctor con comisión
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                </>
                            )}

                            {/* Botones de Agregar/Eliminar Doctor */}
                            {!viewOnly && cantidadDoctores < 3 && (
                                <Box sx={{ display: "flex", gap: "1vw", mt: 3, justifyContent: "center" }}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setCantidadDoctores((prev) => prev + 1)}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            fontSize: "0.8vw",
                                            fontWeight: "bold",
                                            borderRadius: "8px",
                                            padding: "0.4vw 0.8vw",
                                        }}
                                    >
                                        Agregar doctor
                                    </Button>
                                </Box>
                            )}
                        </Paper>

                        <Paper
                            elevation={3}
                            sx={{ p: 2, borderRadius: 4 }}
                            className="paperSelEstudios"
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                        background: "linear-gradient(90deg, #006787, #014e65)",
                                        color: "white",
                                        padding: "0.5vw 1vw",
                                        borderRadius: "8px",
                                        display: "inline-block",
                                    }}
                                >
                                    <Box component="span" sx={{ fontWeight: "bold" }}>
                                        Seleccionar Estudios
                                    </Box>{" "}
                                    <Box component="span" sx={{ fontWeight: "normal" }}>
                                        (Esta utilizando la lista de precios: {selectedLista ? (<Chip label={selectedLista} sx={{ backgroundColor: "#e08505", color: "white", fontWeight: "bold" }} />) : (null)})
                                    </Box>
                                </Typography>
                            </Box>

                            <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                                {" "}
                                <TableHead sx={{ backgroundColor: "#18234f" }}>
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Info.
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Codigo
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Nombre del estudio
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Costo
                                        </TableCell>
                                        {opcionDescuento !== "ninguno" && (
                                            <TableCell
                                                sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    borderRight: "1px solid #ccc",
                                                }}
                                            >
                                                Descuento
                                            </TableCell>
                                        )}
                                        {showFechaMuestraColumn && (
                                            <TableCell
                                                sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    borderRight: "1px solid #ccc",
                                                }}
                                            >
                                                Fecha de muestra
                                            </TableCell>
                                        )}
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Entrega
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                borderBottom: "none",
                                                borderRight: "1px solid #ccc",
                                            }}
                                        >
                                            Eliminar
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {estudios.length > 0 ? (
                                        estudios.map((estudio, index) => (
                                            <React.Fragment key={index}>
                                                <TableRow>
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <IconButton
                                                                onClick={() => mostrarInfo(estudio)}
                                                                sx={{
                                                                    color: "#006787",
                                                                    padding: 0,
                                                                    transition:
                                                                        "transform 0.2s ease, color 0.2s ease",
                                                                    "&:hover": {
                                                                        color: "#014e65",
                                                                        transform: "scale(1.5)",
                                                                    },
                                                                }}
                                                            >
                                                                <InfoIcon sx={{ fontSize: "1.8vw" }} />
                                                            </IconButton>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <Autocomplete
                                                                options={estudiosOptions}
                                                                disabled={viewOnly}
                                                                popupIcon={null}
                                                                getOptionKey={(option) => option.idEstudio}
                                                                getOptionLabel={(option) =>
                                                                    (option && option.codigo) || ""
                                                                }
                                                                value={
                                                                    estudiosOptions.find(
                                                                        (o) => o.idEstudio === estudio.idEstudio,
                                                                    ) || null
                                                                }
                                                                onChange={(e, value) => {
                                                                    enrichEstudioSelection(index, value);
                                                                }}
                                                                isOptionEqualToValue={(option, value) =>
                                                                    option.idEstudio ===
                                                                    (value ? value.idEstudio : null)
                                                                }
                                                                filterOptions={(options, state) =>
                                                                    filterAndRankEstudios(options, state.inputValue)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        fullWidth
                                                                        disabled={viewOnly}
                                                                        sx={{
                                                                            width: "12vw",
                                                                            "& .MuiInputBase-root": { height: "5vh" },
                                                                            "& .MuiInputBase-input": {
                                                                                fontSize: "1vw",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <Autocomplete
                                                                options={estudiosOptions}
                                                                disabled={viewOnly}
                                                                popupIcon={null}
                                                                getOptionKey={(option) => option.idEstudio}
                                                                getOptionLabel={(option) => {
                                                                    if (!option) return "";
                                                                    if (typeof option === "string") return option;
                                                                    return `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`;
                                                                }}
                                                                renderOption={(props, option) => {
                                                                    const { key, ...otherProps } = props;
                                                                    const label = option
                                                                        ? `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`
                                                                        : "";
                                                                    return (
                                                                        <li
                                                                            key={key || option.idEstudio}
                                                                            {...otherProps}
                                                                            style={{ fontSize: "0.9vw" }}
                                                                        >
                                                                            {label}
                                                                        </li>
                                                                    );
                                                                }}
                                                                value={
                                                                    estudiosOptions.find(
                                                                        (o) => o.idEstudio === estudio.idEstudio,
                                                                    ) || null
                                                                }
                                                                onChange={(e, value) => {
                                                                    enrichEstudioSelection(index, value);
                                                                }}
                                                                isOptionEqualToValue={(option, value) =>
                                                                    option.idEstudio ===
                                                                    (value ? value.idEstudio : null)
                                                                }
                                                                filterOptions={(options, state) =>
                                                                    filterAndRankEstudios(options, state.inputValue)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        fullWidth
                                                                        disabled={viewOnly}
                                                                        sx={{
                                                                            width: "24vw",
                                                                            "& .MuiInputBase-root": { height: "5vh" },
                                                                            "& .MuiInputBase-input": {
                                                                                fontSize: "1vw",
                                                                            },
                                                                        }}
                                                                        className="txfNombreEstudioInt"
                                                                    />
                                                                )}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>$</span>
                                                            <TextField
                                                                value={estudio.costo}
                                                                disabled={viewOnly}
                                                                sx={{
                                                                    width: "6vw",
                                                                    "& .MuiInputBase-root": {
                                                                        height: "5vh",
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "1vw",
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    {opcionDescuento !== "ninguno" && (
                                                        <TableCell>
                                                            <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>
                                                                {opcionDescuento === "porcentaje" ? "%" : "$"}
                                                            </span>
                                                            <TextField
                                                                sx={{
                                                                    width: "6vw",
                                                                    "& .MuiInputBase-root": {
                                                                        height: "5vh",
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "1vw",
                                                                    },
                                                                }}
                                                                value={estudio.descuento || ""}
                                                                disabled={viewOnly}
                                                                onChange={(e) =>
                                                                    handleChangeEstudio(
                                                                        index,
                                                                        "descuento",
                                                                        e.target.value,
                                                                    )
                                                                }
                                                            />
                                                            {erroresDescuentoEstudios[index] && (
                                                                <Typography
                                                                    sx={{
                                                                        color: "#d32f2f",
                                                                        fontSize: "0.65vw",
                                                                        fontWeight: "bold",
                                                                        mt: "0.2vw",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {erroresDescuentoEstudios[index]}
                                                                </Typography>
                                                            )}

                                                        </TableCell>
                                                    )}
                                                    {showFechaMuestraColumn && (
                                                        <TableCell>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "0.5vw",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                {Boolean(
                                                                    estudio.muestraPendiente ||
                                                                    `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
                                                                ) ? (
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: "1vw",
                                                                            fontWeight: 700,
                                                                            textTransform: "uppercase",
                                                                            color: "#b8860b",
                                                                        }}
                                                                    >
                                                                        PENDIENTE
                                                                    </Typography>
                                                                ) : (
                                                                    <TextField
                                                                        type="date"
                                                                        size="small"
                                                                        value={formatDateForInput(estudio.fechaMuestra) || getFechaHoy()}
                                                                        disabled={viewOnly || !estudio.idEstudio}
                                                                        onChange={(e) =>
                                                                            handleChangeEstudio(
                                                                                index,
                                                                                "fechaMuestra",
                                                                                e.target.value,
                                                                            )
                                                                        }
                                                                        onBlur={(e) =>
                                                                            handleFechaMuestraBlur(index, e.target.value)
                                                                        }
                                                                        sx={{
                                                                            width: "10vw",
                                                                            "& .MuiInputBase-root": { height: "5vh" },
                                                                            "& .MuiInputBase-input": {
                                                                                fontSize: "0.75vw",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                                <IconButton
                                                                    size="small"
                                                                    disabled={viewOnly}
                                                                    onClick={() => toggleMuestraPendiente(index)}
                                                                    sx={{
                                                                        backgroundColor:
                                                                            estudio.muestraPendiente ||
                                                                                `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE"
                                                                                ? "#f9a825"
                                                                                : "#d32f2f",
                                                                        color: "white",
                                                                        '&:hover': {
                                                                            backgroundColor:
                                                                                estudio.muestraPendiente ||
                                                                                    `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE"
                                                                                    ? "#f7b600"
                                                                                    : "#c62828",
                                                                        },
                                                                    }}
                                                                >
                                                                    {Boolean(
                                                                        estudio.muestraPendiente ||
                                                                        `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
                                                                    ) ? (
                                                                        <CalendarTodayIcon sx={{ fontSize: "1.1vw" }} />
                                                                    ) : (
                                                                        <AccessTimeIcon sx={{ fontSize: "1.1vw" }} />
                                                                    )}
                                                                </IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "0.2vw",
                                                            }}
                                                        >
                                                            {asignarFecha ? (
                                                                <TextField
                                                                    type="date"
                                                                    size="small"
                                                                    value={formatDateForInput(estudio.fechaEntrega) || ""}
                                                                    disabled={viewOnly || !estudio.idEstudio}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        handleChangeEstudio(index, "fechaEntrega", val);
                                                                    }}
                                                                    sx={{
                                                                        width: "10vw",
                                                                        "& .MuiInputBase-root": { height: "5vh" },
                                                                        "& .MuiInputBase-input": { fontSize: "1vw" },
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Typography
                                                                    sx={{
                                                                        color: "#18234f",
                                                                        fontSize: "1vw",
                                                                        fontWeight: "600",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {estudio.fechaEntrega || "—"}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            size="large"
                                                            sx={{ color: "red" }}
                                                            disabled={viewOnly || ["P", "PC"].includes(`${solicitudEstatus ?? ""}`.trim().toUpperCase())}
                                                            onClick={() => handleRemoveEstudio(index)}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "1.8vw" }} />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6 + (opcionDescuento !== "ninguno" ? 1 : 0) + (showFechaMuestraColumn ? 1 : 0)} align="center" sx={{ py: 4 }}>
                                                No hay registros
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "0.5vw",
                                }}
                            >
                                <IconButton sx={{ color: "#006787" }} disabled={viewOnly} onClick={addEstudio}>
                                    Añadir estudio
                                    <AddIcon />
                                </IconButton>
                            </Box>
                            <Stack
                                direction="row"
                                spacing={"10vw"}
                                sx={{ paddingTop: "4vw" }}
                            >
                                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                                    {" "}
                                    <TableHead sx={{ backgroundColor: "#18234f" }}>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    borderRight: "1px solid #ccc",
                                                }}
                                            >
                                                Entrega de resultados
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <FormControl>
                                                    <RadioGroup
                                                        column
                                                        name="entregaResultados"
                                                        value={modoEntrega}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            setModoEntrega(val);
                                                            setAsignarFecha(val === "asignarFecha");
                                                            if (val === "normal") {
                                                                setFechaGlobal("");
                                                                setEstudios((prev) =>
                                                                    prev.map((est) => ({
                                                                        ...est,
                                                                        fechaEntrega: est.idEstudio ? calcularFechaEntrega(est.tiempoEntrega) : "",
                                                                        urgente: false,
                                                                    }))
                                                                );
                                                            }
                                                        }}
                                                        disabled={viewOnly}
                                                    >
                                                        <FormControlLabel
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "1vw",
                                                                    fontWeight: "bold",
                                                                },
                                                            }}
                                                            value="asignarFecha"
                                                            control={
                                                                <Radio
                                                                    disabled={viewOnly}
                                                                    sx={{
                                                                        "& .MuiSvgIcon-root": {
                                                                            height: "1vw",
                                                                            width: "1vw",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label="Asignar Fecha"
                                                        />
                                                        {modoEntrega === "asignarFecha" && (
                                                            <TextField
                                                                type="date"
                                                                size="small"
                                                                disabled={viewOnly}
                                                                value={fechaGlobal}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    setFechaGlobal(val);
                                                                    setEstudios((prev) =>
                                                                        prev.map((est) => ({
                                                                            ...est,
                                                                            fechaEntrega: est.idEstudio ? val : "",
                                                                            urgente: est.idEstudio ? true : false,
                                                                        }))
                                                                    );
                                                                }}
                                                                sx={{
                                                                    mt: "0.3vw",
                                                                    mb: "0.5vw",
                                                                    "& .MuiInputBase-root": { height: "5vh" },
                                                                    "& .MuiInputBase-input": { fontSize: "1vw" },
                                                                }}
                                                            />
                                                        )}
                                                        <FormControlLabel
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "1vw",
                                                                    fontWeight: "bold",
                                                                },
                                                            }}
                                                            value="normal"
                                                            control={
                                                                <Radio
                                                                    disabled={viewOnly}
                                                                    sx={{
                                                                        "& .MuiSvgIcon-root": {
                                                                            height: "1vw",
                                                                            width: "1vw",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label="Normal"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                                    {" "}
                                    <TableHead sx={{ backgroundColor: "#18234f" }}>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    borderRight: "1px solid #ccc",
                                                }}
                                            >
                                                Descuento general solicitud
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #ddd" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={requiereFactura}
                                                            disabled={viewOnly}
                                                            onChange={(e) => setRequiereFactura(e.target.checked)}
                                                            sx={{
                                                                color: "#18234f",
                                                                "&.Mui-checked": { color: "#006787" },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "#18234f" }}>
                                                            ¿Requiere factura? (IVA 16%)
                                                        </Typography>
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormControl>
                                                    <RadioGroup row
                                                        disabled={viewOnly}
                                                        value={opcionDescuento}
                                                        onChange={(e) =>
                                                            handleChangeOpcionDescuento(e.target.value)
                                                        }
                                                    >
                                                        <FormControlLabel
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "1vw",
                                                                    fontWeight: "bold",
                                                                },
                                                            }}
                                                            value="porcentaje"
                                                            control={
                                                                <Radio
                                                                    disabled={viewOnly}
                                                                    sx={{
                                                                        "& .MuiSvgIcon-root": {
                                                                            height: "1vw",
                                                                            width: "1vw",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label="Porcentaje"
                                                        />
                                                        <FormControlLabel
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "1vw",
                                                                    fontWeight: "bold",
                                                                },
                                                            }}
                                                            value="cantidad"
                                                            control={
                                                                <Radio
                                                                    disabled={viewOnly}
                                                                    sx={{
                                                                        "& .MuiSvgIcon-root": {
                                                                            height: "1vw",
                                                                            width: "1vw",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label="Cantidad"
                                                        />
                                                        <FormControlLabel
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "1vw",
                                                                    fontWeight: "bold",
                                                                },
                                                            }}
                                                            value="ninguno"
                                                            control={
                                                                <Radio
                                                                    disabled={viewOnly}
                                                                    sx={{
                                                                        "& .MuiSvgIcon-root": {
                                                                            height: "1vw",
                                                                            width: "1vw",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label="Ninguno"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            {opcionDescuento !== "ninguno" && (
                                                <TableCell>
                                                    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <Typography
                                                                sx={{
                                                                    backgroundColor: "#172149",
                                                                    width: "10vw",
                                                                    color: "white",
                                                                    fontSize: "1vw",
                                                                    padding: "0.3vw 0.5vw",
                                                                    borderRadius: "6px",
                                                                    textAlign: "center",
                                                                    marginBottom: "0.5vw",
                                                                }}
                                                            >
                                                                {opcionDescuento === "cantidad"
                                                                    ? "Coloque cantidad a descontar:"
                                                                    : "Coloque porcentaje general:"}
                                                            </Typography>
                                                            <TextField
                                                                value={valorGeneralMostrado}
                                                                disabled={viewOnly}
                                                                onChange={(e) =>
                                                                    handleChangeValorGeneral(e.target.value)
                                                                }
                                                                InputProps={{
                                                                    [opcionDescuento === "porcentaje" ? "endAdornment" : "startAdornment"]: (
                                                                        <InputAdornment position={opcionDescuento === "porcentaje" ? "end" : "start"}>
                                                                            {opcionDescuento === "porcentaje" ? "%" : "$"}
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                                sx={{
                                                                    width: "11vw",
                                                                    "& .MuiInputBase-root": {
                                                                        height: "5vh",
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        textAlign: "center",
                                                                        fontSize: "1vw",
                                                                    },
                                                                }}
                                                            />
                                                            {errorDescuentoGeneral && (
                                                                <Typography
                                                                    sx={{
                                                                        color: "#d32f2f",
                                                                        fontSize: "0.75vw",
                                                                        fontWeight: "bold",
                                                                        mt: "0.3vw",
                                                                        textAlign: "center",
                                                                        maxWidth: "11vw",
                                                                    }}
                                                                >
                                                                    {errorDescuentoGeneral}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <Typography
                                                                sx={{
                                                                    backgroundColor: "#172149",
                                                                    width: "10vw",
                                                                    color: "white",
                                                                    fontSize: "1vw",
                                                                    padding: "0.3vw 0.5vw",
                                                                    borderRadius: "6px",
                                                                    textAlign: "center",
                                                                    marginBottom: "0.5vw",
                                                                    marginTop: "1.4vw",
                                                                }}
                                                            >
                                                                Motivo del descuento:
                                                            </Typography>
                                                            <TextField
                                                                value={motivoDescuento}
                                                                disabled={viewOnly}
                                                                onChange={(e) => setMotivoDescuento(e.target.value)}
                                                                sx={{
                                                                    width: "11vw",
                                                                    "& .MuiInputBase-root": {
                                                                        height: "5vh",
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        textAlign: "center",
                                                                        fontSize: "1vw",
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <Table sx={{ backgroundColor: "white", tableLayout: "fixed", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                                    <TableBody>
                                        <>
                                            {showEstadoRow && (
                                                <TableRow>
                                                    <TableCell
                                                        sx={{
                                                            backgroundColor: "#18234f",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Estado
                                                    </TableCell>
                                                    <TableCell>{solicitudEstatusLabel}</TableCell>
                                                </TableRow>
                                            )}
                                            <TableRow>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor: "#18234f",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Subtotal
                                                </TableCell>
                                                <TableCell>$ {subtotalResumen.toFixed(2)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor: "#18234f",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Descuento
                                                </TableCell>
                                                <TableCell>$ {descuentoResumen.toFixed(2)}</TableCell>
                                            </TableRow>
                                            {requiereFactura && (
                                                <TableRow>
                                                    <TableCell
                                                        sx={{
                                                            backgroundColor: "#18234f",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        IVA (16%)
                                                    </TableCell>
                                                    <TableCell>$ {ivaResumen.toFixed(2)}</TableCell>
                                                </TableRow>
                                            )}
                                            <TableRow>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor: "#18234f",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Total
                                                </TableCell>
                                                <TableCell>$ {totalResumen.toFixed(2)}</TableCell>
                                            </TableRow>
                                            {showExtendedTotals && (
                                                <>
                                                    <TableRow>
                                                        <TableCell
                                                            sx={{
                                                                backgroundColor: "#18234f",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            Pagado
                                                        </TableCell>
                                                        <TableCell>$ {aCuentaMonto.toFixed(2)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell
                                                            sx={{
                                                                backgroundColor: "#18234f",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            Adeudo
                                                        </TableCell>
                                                        <TableCell>$ {restanteMonto.toFixed(2)}</TableCell>
                                                    </TableRow>
                                                </>
                                            )}
                                        </>
                                    </TableBody>
                                </Table>
                            </Stack>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    paddingTop: "3vw",
                                }}
                            >
                                <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                        background: "linear-gradient(90deg, #006787, #014e65)",
                                        color: "white",
                                        padding: "0.5vw 1vw",
                                        borderRadius: "8px",
                                        display: "inline-block",
                                        whiteSpace: "pre-line",
                                        textAlign: "center",
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{ fontWeight: "bold", justifyContent: "center" }}
                                    >
                                        Notas adicionales que desee agregar a la solicitud
                                    </Box>
                                    <br />
                                    <Box component="span" sx={{ fontWeight: "normal" }}>
                                        (Se mostrarán en la Orden de Trabajo y en el modulo de
                                        reporte de resultados)
                                    </Box>
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    paddingTop: "3vw",
                                }}
                            >
                                <TextField
                                    fullWidth
                                    onChange={(e) =>
                                        setNotas(e.target.value)}
                                    disabled={viewOnly}
                                    value={notas}
                                    multiline
                                    minRows={1}
                                    maxRows={4}
                                    sx={{

                                        "& .MuiInputBase-root": {},
                                        "& .MuiInputBase-input": {
                                            fontSize: "1vw",
                                        },
                                    }}
                                />
                            </Box>
                        </Paper>
                    </Stack>
                </Box>
                <Box
                    sx={{
                        position: "fixed",
                        right: "6vw",
                        top: "30%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    {!viewOnly && (
                        <Tooltip
                            title={"Guardar solicitud"}
                            arrow
                            placement="right"
                            slotProps={{
                                popper: {
                                    sx: {
                                        [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                        {
                                            marginTop: "0px",
                                        },
                                        [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                        {
                                            marginBottom: "0.2vw",
                                        },
                                        [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                                        {
                                            marginLeft: "0px",
                                        },
                                        [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                                        {
                                            marginRight: "0px",
                                        },
                                    },
                                },
                                tooltip: {
                                    sx: {
                                        fontSize: "0.7vw",
                                        padding: "0.5vw 0.5vw",
                                        borderRadius: "8px",
                                        backgroundColor: "rgba(255,255,255,0.9)",
                                        fontWeight: "bold",
                                        fontFamily: "Roboto-Medium",
                                        color: "#000000",
                                        marginBottom: "-5px",
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: "rgba(255,255,255,0.9)",
                                    },
                                },
                            }}
                        >
                            <IconButton
                                disabled={Boolean(errorDescuentoGeneral || erroresDescuentoEstudios.some(Boolean))}
                                onClick={agregarSolicitud}
                                sx={{
                                    backgroundColor: "#ffffff",
                                    color: "#18234f",
                                    "&:hover": { backgroundColor: "#d1d1d1" },
                                    "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                                    width: "4vw",
                                    height: "4vw",
                                }}
                            >
                                <SaveIcon sx={{ fontSize: "1.8vw" }} />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Tooltip
                        title={"Nueva solicitud"}
                        arrow
                        placement="right"
                        slotProps={{
                            popper: {
                                sx: {
                                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                    {
                                        marginTop: "0px",
                                    },
                                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                    {
                                        marginBottom: "0.2vw",
                                    },
                                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                                    {
                                        marginLeft: "0px",
                                    },
                                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                                    {
                                        marginRight: "0px",
                                    },
                                },
                            },
                            tooltip: {
                                sx: {
                                    fontSize: "0.7vw",
                                    padding: "0.5vw 0.5vw",
                                    borderRadius: "8px",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    fontWeight: "bold",
                                    fontFamily: "Roboto-Medium",
                                    color: "#000000",
                                    marginBottom: "-5px",
                                },
                            },
                            arrow: {
                                sx: {
                                    color: "rgba(255,255,255,0.9)",
                                },
                            },
                        }}
                    >
                        <IconButton
                            sx={{
                                backgroundColor: "#ffffff",
                                color: "#18234f",
                                "&:hover": { backgroundColor: "#d1d1d1" },
                                width: "4vw",
                                height: "4vw",
                            }}
                            onClick={reloadPage}
                        >
                            <AddIcon sx={{ fontSize: "1.8vw" }} />
                        </IconButton>
                    </Tooltip>


                </Box>
            </Content>
        </Layout>
    );
};
export default CargaMasiva;
